<template>
  <div v-if="userData !== null && userData !== '' && userData !== undefined"> 
    <div id="kt_header" class="header" data-kt-sticky="true" data-kt-sticky-name="header" data-kt-sticky-offset="{default: '200px', lg: '300px'}">
      <div class="container-xxl d-flex flex-grow-1 flex-stack">
        <div class="d-flex align-items-center me-5">
          <div class="d-lg-none btn btn-icon btn-active-color-primary w-30px h-30px ms-n2 me-3" id="kt_header_menu_toggle">
            <span class="svg-icon svg-icon-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z" fill="currentColor"/>
                <path opacity="0.3" d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z" fill="currentColor"/>
              </svg>
            </span>
          </div>

          <a href="/" class="mb-2"> 
            <img alt="Logo" src="assets/theme/media/logos/logo-cc.png" class="m-4 mb-0 ms-0"/>
            <br>
            <span v-if="selectedCompany !== null && selectedCompany !== '' && selectedCompany !== undefined && selectedCompany.id !== null" class="fs-9 ps-3 pe-3 justify-content-center text-center" 
                  style="background-color: #272639; color: #c0c0c5; border: 1px solid #151420 !important; margin-left: 55px !important;"> 
                  {{ selectedCompany.company_name }}
            </span>
          </a>
        </div>

        <div class="topbar d-flex align-items-stretch flex-shrink-0" id="kt_topbar">
          <div class="d-flex align-items-center ms-2 ms-lg-3" id="kt_header_user_menu_toggle">
            <div class="cursor-pointer symbol symbol-30px symbol-md-40px"
              data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
              data-kt-menu-attach="parent"
              data-kt-menu-placement="bottom-end">

              <img src="assets/theme/media/avatars/300-1.jpg" alt="user" />
            </div>

            <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px"
            data-kt-menu="true">
              <div class="menu-item px-3">
                <div class="menu-content d-flex align-items-center px-3">
                  <div class="symbol symbol-50px me-5">
                    <img alt="Logo" src="assets/theme/media/avatars/300-1.jpg"/>
                  </div>

                  <div class="d-flex flex-column">
                    <div class="fw-bolder d-flex align-items-center fs-5 text-break">{{ userData.name_surname }} </div>  
                    <a class="fw-bold text-muted text-hover-primary fs-7 text-break">{{ userData.user_mail }}</a>
                    <div class="fw-bolder d-flex align-items-center mt-4">
                     <span class="badge badge-light-info fw-bolder fs-8 px-2 py-1" v-if="userData.account_type == 1">System</span>
                      <span class="badge badge-light-primary fw-bolder fs-8 px-2 py-1" v-if="userData.account_type == 2">Controller</span>
                      <span class="badge badge-light-warning fw-bolder fs-8 px-2 py-1" v-if="userData.account_type == 3">Company</span>
                       <span class="badge badge-light-danger fw-bolder fs-8 px-2 py-1 ms-2" v-if="userData.permission_type == 1">Admin</span>
                      <span class="badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2" v-if="userData.permission_type == 2">Client</span> 
                    </div>
                  </div>
                </div>
              </div>

              <div class="separator my-2"></div>

              <div class="menu-item px-5">
                <router-link :to="{ name: 'UserAdminProfile' }">
                  <a href="" class="menu-link px-5">User Profile</a>
                </router-link>
              </div>
              <div class="separator my-2"></div>
              <div class="menu-item px-5" data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-placement="left-start" data-kt-menu-offset="-15px, 0">
                <a href="#" class="menu-link px-5">
                    <span class="menu-title position-relative">
                      Mode
                      <span class="ms-5 position-absolute translate-middle-y top-50 end-0">
                        <i class="bi bi-brightness-high-fill theme-light-show"></i>
                        <i class="bi bi-moon-stars-fill theme-dark-show"></i>
                      </span>
                    </span>
                </a>
                         <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-gray-500 menu-active-bg menu-state-color fw-semibold py-4 fs-base w-150px"
                    data-kt-menu="true" data-kt-element="theme-mode-menu" style="">
                    <div class="menu-item px-3 my-0">
                        <a href="#" class="menu-link px-3 py-2" :class="{'active': themeName == 'light' }" 
                          data-kt-element="mode" data-kt-value="light" @click="changeTheme('light')">
                            <span class="menu-icon" data-kt-element="icon">
                              <i class="bi bi-brightness-high-fill"></i>
                            </span>
                            <span class="menu-title">
                              Light
                            </span>
                        </a>
                    </div>
                    <div class="menu-item px-3 my-0">
                        <a href="#" class="menu-link px-3 py-2" :class="{'active': themeName == 'dark' }"  
                          data-kt-element="mode" data-kt-value="dark" @click="changeTheme('dark')">
                            <span class="menu-icon" data-kt-element="icon">
                              <i class="bi bi-moon-stars-fill"></i>
                            </span>
                            <span class="menu-title">
                              Dark
                            </span>
                        </a>
                    </div>
                    <div class="menu-item px-3 my-0">
                      <a href="#" class="menu-link px-3 py-2" :class="{'active': themeName == 'system' }" 
                          data-kt-element="mode" data-kt-value="system" @click="changeTheme('system')">
                          <span class="menu-icon" data-kt-element="icon">
                            <i class="bi bi-display"></i>
                          </span>
                          <span class="menu-title">
                             System
                          </span>
                      </a>
                    </div>
                </div>
              </div>
              <div class="separator my-2"></div> 
              <div class="menu-item px-5">
                <a href="" class="menu-link px-5" @click="signOut()">Sign Out</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="header-menu-container d-flex align-items-stretch flex-stack h-lg-75px w-100" id="kt_header_nav">
        <div class="header-menu container-xxl flex-column align-items-stretch flex-lg-row"
          data-kt-drawer="true"
          data-kt-drawer-name="header-menu"
          data-kt-drawer-activate="{default: true, lg: false}"
          data-kt-drawer-overlay="true"
          data-kt-drawer-width="{default:'200px', '300px': '250px'}"
          data-kt-drawer-direction="start"
          data-kt-drawer-toggle="#kt_header_menu_toggle"
          data-kt-swapper="true"
          data-kt-swapper-mode="prepend"
          data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header_nav'}">
          <div class="menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch flex-grow-1" id="#kt_header_menu" data-kt-menu="true">
            
            <div data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-placement="bottom-start" class="menu-item menu-lg-down-accordion me-0 me-lg-2">
              <router-link class="menu-link py-3" :to="{ name: 'Home' }">
                  <span class="menu-title ">Home</span>
                  <span class="menu-arrow d-lg-none"></span>
              </router-link>
            </div>
            
            <div data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-placement="bottom-start" class="menu-item menu-lg-down-accordion me-0 me-lg-2"
                 v-if="userData.controller_account_id !== null && userData.controller_account_id !== '' && userData.controller_account_id !== undefined">
              <span class="menu-link py-3">
                <span class="menu-title">Controller Functions</span>
                <span class="menu-arrow d-lg-none"></span>
              </span> 
              <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown p-0 w-100 w-lg-600px" style="">
                <div class="menu-state-bg menu-extended"> 
                  <div class="row">
                    <div class="col-lg-12 mb-3 mb-lg-0 py-3 px-3 py-lg-6 px-lg-6">
                      <div class="row">
                        <div class="col-lg-6 mb-3">
                          <router-link :to="{ name: 'YourCompanies' }">
                            <div class="menu-item p-0 m-0">
                              <a href="" class="menu-link">
                                <span class="menu-custom-icon d-flex flex-center flex-shrink-0 rounded w-40px h-40px me-3">
                                  <span class="svg-icon svg-icon-primary svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.0173 9H15.3945C14.2833 9 13.263 9.61425 12.7431 10.5963L12.154 11.7091C12.0645 11.8781 12.1072 12.0868 12.2559 12.2071L12.6402 12.5183C13.2631 13.0225 13.7556 13.6691 14.0764 14.4035L14.2321 14.7601C14.2957 14.9058 14.4396 15 14.5987 15H18.6747C19.7297 15 20.4057 13.8774 19.912 12.945L18.6686 10.5963C18.1487 9.61425 17.1285 9 16.0173 9Z" fill="currentColor"/>
                                      <rect opacity="0.3" x="14" y="4" width="4" height="4" rx="2" fill="currentColor"/>
                                      <path d="M4.65486 14.8559C5.40389 13.1224 7.11161 12 9 12C10.8884 12 12.5961 13.1224 13.3451 14.8559L14.793 18.2067C15.3636 19.5271 14.3955 21 12.9571 21H5.04292C3.60453 21 2.63644 19.5271 3.20698 18.2067L4.65486 14.8559Z" fill="currentColor"/>
                                      <rect opacity="0.3" x="6" y="5" width="6" height="6" rx="3" fill="currentColor"/>
                                  </svg>
                                  </span>
                                </span>
                                <span class="d-flex flex-column">
                                  <span class="fs-6 fw-bold text-gray-800">Your Companies</span>
                                  <span class="fs-7 fw-semibold text-muted"></span>
                                  <!-- Full width DX tablosu Company Name başında Controller olacak -->
                                </span>
                              </a>
                            </div>
                            </router-link>
                        </div>
                        <div class="col-lg-6 mb-3">
                          <router-link :to="{ name: 'CompaniesHouseList' }">
                            <div class="menu-item p-0 m-0">
                              <a href="" class="menu-link">
                                <span class="menu-custom-icon d-flex flex-center flex-shrink-0 rounded w-40px h-40px me-3">
                                  <span class="svg-icon svg-icon-info svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20 19.725V18.725C20 18.125 19.6 17.725 19 17.725H5C4.4 17.725 4 18.125 4 18.725V19.725H3C2.4 19.725 2 20.125 2 20.725V21.725H22V20.725C22 20.125 21.6 19.725 21 19.725H20Z" fill="currentColor"/>
                                    <path opacity="0.3" d="M22 6.725V7.725C22 8.325 21.6 8.725 21 8.725H18C18.6 8.725 19 9.125 19 9.725C19 10.325 18.6 10.725 18 10.725V15.725C18.6 15.725 19 16.125 19 16.725V17.725H15V16.725C15 16.125 15.4 15.725 16 15.725V10.725C15.4 10.725 15 10.325 15 9.725C15 9.125 15.4 8.725 16 8.725H13C13.6 8.725 14 9.125 14 9.725C14 10.325 13.6 10.725 13 10.725V15.725C13.6 15.725 14 16.125 14 16.725V17.725H10V16.725C10 16.125 10.4 15.725 11 15.725V10.725C10.4 10.725 10 10.325 10 9.725C10 9.125 10.4 8.725 11 8.725H8C8.6 8.725 9 9.125 9 9.725C9 10.325 8.6 10.725 8 10.725V15.725C8.6 15.725 9 16.125 9 16.725V17.725H5V16.725C5 16.125 5.4 15.725 6 15.725V10.725C5.4 10.725 5 10.325 5 9.725C5 9.125 5.4 8.725 6 8.725H3C2.4 8.725 2 8.325 2 7.725V6.725L11 2.225C11.6 1.925 12.4 1.925 13.1 2.225L22 6.725ZM12 3.725C11.2 3.725 10.5 4.425 10.5 5.225C10.5 6.025 11.2 6.725 12 6.725C12.8 6.725 13.5 6.025 13.5 5.225C13.5 4.425 12.8 3.725 12 3.725Z" fill="currentColor"/>
                                  </svg>
                                  </span>
                                </span>
                                <span class="d-flex flex-column">
                                  <span class="fs-6 fw-bold text-gray-800">Companies House List</span>
                                  <span class="fs-7 fw-semibold text-muted"></span>
                                </span>
                              </a>
                            </div>
                            </router-link>
                        </div>
                      </div>
                    </div>
                  </div> 
                </div> 
              </div>
            </div>
            <div v-if="!this.$isSystemAdmin()" data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-placement="bottom-start" class="menu-item menu-lg-down-accordion me-0 me-lg-2">
              <span class="menu-link py-3">
                <span class="menu-title">Company Functions</span>
                <span class="menu-arrow d-lg-none"></span>
              </span> 
              <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown p-0 w-100 w-lg-600px" style="">
                <div class="menu-state-bg menu-extended"> 
                  <div class="row">
                    <div class="col-lg-12 mb-3 mb-lg-0 py-3 px-3 py-lg-6 px-lg-6">
                      <div class="row">
                        <div class="col-lg-6 mb-3">
                          <router-link :to="{ name: 'Liabilities' }">
                          <div class="menu-item p-0 m-0">
                            <a href="" class="menu-link">
                              <span class="menu-custom-icon d-flex flex-center flex-shrink-0 rounded w-40px h-40px me-3">
                                <span class="svg-icon svg-icon-primary svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M16.0173 9H15.3945C14.2833 9 13.263 9.61425 12.7431 10.5963L12.154 11.7091C12.0645 11.8781 12.1072 12.0868 12.2559 12.2071L12.6402 12.5183C13.2631 13.0225 13.7556 13.6691 14.0764 14.4035L14.2321 14.7601C14.2957 14.9058 14.4396 15 14.5987 15H18.6747C19.7297 15 20.4057 13.8774 19.912 12.945L18.6686 10.5963C18.1487 9.61425 17.1285 9 16.0173 9Z" fill="currentColor"/>
                                    <rect opacity="0.3" x="14" y="4" width="4" height="4" rx="2" fill="currentColor"/>
                                    <path d="M4.65486 14.8559C5.40389 13.1224 7.11161 12 9 12C10.8884 12 12.5961 13.1224 13.3451 14.8559L14.793 18.2067C15.3636 19.5271 14.3955 21 12.9571 21H5.04292C3.60453 21 2.63644 19.5271 3.20698 18.2067L4.65486 14.8559Z" fill="currentColor"/>
                                    <rect opacity="0.3" x="6" y="5" width="6" height="6" rx="3" fill="currentColor"/>
                                </svg>
                                </span>
                              </span>
                              <span class="d-flex flex-column">
                                <span class="fs-6 fw-bold text-gray-800">Companies Liabilities</span>
                                <span class="fs-7 fw-semibold text-muted"></span>
                              </span>
                            </a>
                          </div>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div> 
                </div> 
              </div>
            </div>
            <div v-if="selectedCompanyName == null || selectedCompanyName == '' || selectedCompanyName == undefined" 
              data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-placement="bottom-start" class="menu-item menu-lg-down-accordion me-lg-1">
              <a href="" class="menu-link py-3" data-bs-toggle="modal" data-bs-target="#kt_modal_select_company" @click="getData()">
                <span class="menu-title">
                    <span> <i class="bi bi-search fs-8 me-2"></i> Select Company </span>
                </span>
              </a>
            </div>  
            <div v-if="this.$isSystemAdmin()" data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-placement="bottom-start" class="menu-item menu-lg-down-accordion me-0 me-lg-2">
              <span class="menu-link py-3">
                <span class="menu-title">System Reports</span>
                <span class="menu-arrow d-lg-none"></span>
              </span> 
              <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown p-0 w-100 w-lg-600px" style="">
                <div class="menu-state-bg menu-extended"> 
                  <div class="row">
                    <div class="col-lg-12 mb-3 mb-lg-0 py-3 px-3 py-lg-6 px-lg-6">
                      <div class="row">
                        <div class="col-lg-6 mb-3">
                          <router-link :to="{ name: 'ConsolidationReports' }">
                          <div class="menu-item p-0 m-0">
                            <a href="" class="menu-link">
                              <span class="menu-custom-icon d-flex flex-center flex-shrink-0 rounded w-40px h-40px me-3">
                                <span class="svg-icon svg-icon-primary svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M16.0173 9H15.3945C14.2833 9 13.263 9.61425 12.7431 10.5963L12.154 11.7091C12.0645 11.8781 12.1072 12.0868 12.2559 12.2071L12.6402 12.5183C13.2631 13.0225 13.7556 13.6691 14.0764 14.4035L14.2321 14.7601C14.2957 14.9058 14.4396 15 14.5987 15H18.6747C19.7297 15 20.4057 13.8774 19.912 12.945L18.6686 10.5963C18.1487 9.61425 17.1285 9 16.0173 9Z" fill="currentColor"/>
                                    <rect opacity="0.3" x="14" y="4" width="4" height="4" rx="2" fill="currentColor"/>
                                    <path d="M4.65486 14.8559C5.40389 13.1224 7.11161 12 9 12C10.8884 12 12.5961 13.1224 13.3451 14.8559L14.793 18.2067C15.3636 19.5271 14.3955 21 12.9571 21H5.04292C3.60453 21 2.63644 19.5271 3.20698 18.2067L4.65486 14.8559Z" fill="currentColor"/>
                                    <rect opacity="0.3" x="6" y="5" width="6" height="6" rx="3" fill="currentColor"/>
                                </svg>
                                </span>
                              </span>
                              <span class="d-flex flex-column">
                                <span class="fs-6 fw-bold text-gray-800">Consolidation Reports</span>
                                <span class="fs-7 fw-semibold text-muted"></span>
                              </span>
                            </a>
                          </div>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div> 
                </div> 
              </div>
            </div>
          </div>
          <div class="d-flex align-items-stretch flex-shrink-0 p-4 p-lg-0 me-lg-2" id="kt_header_search_wrapper" v-if="userData.is_chatbi_user == 1">
            <div class="menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch flex-grow-1" id="#kt_header_menu"
            data-kt-menu="true">
              <div class="menu-item me-lg-1 cursor-pointer" @click="openChatBi()" data-bs-toggle="modal" data-bs-target="#chatbi_modal">
                <span class=" ">
                  <span class="menu-title">
                    <span class="svg-icon svg-icon-success svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.3" d="M8 8C8 7.4 8.4 7 9 7H16V3C16 2.4 15.6 2 15 2H3C2.4 2 2 2.4 2 3V13C2 13.6 2.4 14 3 14H5V16.1C5 16.8 5.79999 17.1 6.29999 16.6L8 14.9V8Z" fill="currentColor"/>
                    <path d="M22 8V18C22 18.6 21.6 19 21 19H19V21.1C19 21.8 18.2 22.1 17.7 21.6L15 18.9H9C8.4 18.9 8 18.5 8 17.9V7.90002C8 7.30002 8.4 6.90002 9 6.90002H21C21.6 7.00002 22 7.4 22 8ZM19 11C19 10.4 18.6 10 18 10H12C11.4 10 11 10.4 11 11C11 11.6 11.4 12 12 12H18C18.6 12 19 11.6 19 11ZM17 15C17 14.4 16.6 14 16 14H12C11.4 14 11 14.4 11 15C11 15.6 11.4 16 12 16H16C16.6 16 17 15.6 17 15Z" fill="currentColor"/>
                    </svg>
                    </span>
                  </span>
                  <span class="menu-arrow d-lg-none"></span>
                </span>
              </div>
              <span class="badge badge-circle badge-danger badge-sm" v-if="unReadMessageCount > 0">
                {{ unReadMessageCount }}
              </span> 
            </div>
          </div>
          <div class="d-flex align-items-stretch flex-shrink-0 p-4 p-lg-0 me-lg-2" id="kt_header_search_wrapper" v-if="(userData.account_type == 1) || (userData.account_type > 1 && userData.permission_type == 1)">
            <div class="menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch flex-grow-1" id="#kt_header_menu"
            data-kt-menu="true">
            <div class="menu-item me-lg-1">
              <router-link class= "menu-link py-3" :to="{ name: 'Settings' }">
                <span class=" ">
                  <span class="menu-title">
                    <i class="bi bi-gear fs-1"></i> 
                  </span>
                  <span class="menu-arrow d-lg-none"></span>
                </span>
              </router-link>
            </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="{'d-none': selectedCompanyName == null || selectedCompanyName == undefined || selectedCompanyName == ''}"
        class="header-menu-container d-flex align-items-stretch flex-stack h-lg-50px w-100 bg-danger bg-opacity-50" id="kt_header_nav_2">
        <div class="header-menu container-xxl flex-column align-items-stretch flex-lg-row" data-kt-drawer="true"
          data-kt-drawer-name="header-menu" data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true"
          data-kt-drawer-width="{default:'200px', '300px': '250px'}" data-kt-drawer-direction="start" data-kt-drawer-toggle="#kt_header_menu_2_toggle"
          data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header_nav_2'}">
          <div class="menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 ms-lg-3 align-items-stretch flex-grow-1" id="#kt_header_menu_2"
            data-kt-menu="true">
            <div class="d-flex align-items-center flex-shrink-0">
              <span class="text-white fw-boldest fs-6 me-3">
                {{this.selectedCompanyName}}
              </span>
            </div>
            <div class="d-flex align-items-stretch flex-shrink-0 p-4 p-lg-0 me-lg-2" id="kt_header_search_wrapper">
              <div class="menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch flex-grow-1" id="#kt_header_menu"
              data-kt-menu="true">
              <div class="menu-item me-lg-1" data-bs-toggle="modal" data-bs-target="#kt_modal_select_company" @click="getData()">
                  <span class="menu-link active bg-hover-dark py-1 px-2">
                    <span class="menu-title fs-7">
                      <i class="bi bi-arrow-clockwise me-2 fs-7"></i> 
                      Change Company
                    </span>
                    <span class="menu-arrow d-lg-none"></span>
                  </span>
              </div>
              <div class="menu-item me-lg-1" @click="onExitCompany()">
                  <span class="menu-link active bg-hover-dark py-1 px-2">
                    <span class="menu-title fs-7">
                      <i class="bi bi-x-lg me-2 fs-7"></i> 
                      Exit
                    </span>
                    <span class="menu-arrow d-lg-none"></span>
                  </span>
              </div>
              </div>
            </div>
          </div> 
          <div class="menu menu-lg-rounded menu-end menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch flex-grow-1" id="#kt_header_menu_2"
            data-kt-menu="true">
            <div data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-placement="bottom-start" class="menu-item menu-lg-down-accordion me-0 me-lg-2">
                <span class="menu-link py-3">
                    <span class="menu-title">View Company</span>
                    <span class="menu-arrow d-lg-none"></span>
                </span> 
                <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown p-0 w-100 w-lg-300px">
                    <div class="menu-state-bg menu-extended"> 
                        <div class="row">
                            <div class="col-lg-12 mb-3 mb-lg-0 py-3 px-3 py-lg-6 px-lg-6">
                                <div class="row">
                                    <div class="col-lg-12 mb-3">
                                        <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion"> 
                                            <div class="menu-item p-0 m-0">
                                                <a href="#" class="menu-link">
                                                    <span class="menu-custom-icon d-flex flex-center flex-shrink-0 rounded w-40px h-40px me-3">  
                                                        <span class="svg-icon svg-icon-primary svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path opacity="0.3" d="M5.78001 21.115L3.28001 21.949C3.10897 22.0059 2.92548 22.0141 2.75004 21.9727C2.57461 21.9312 2.41416 21.8418 2.28669 21.7144C2.15923 21.5869 2.06975 21.4264 2.0283 21.251C1.98685 21.0755 1.99507 20.892 2.05201 20.7209L2.886 18.2209L7.22801 13.879L10.128 16.774L5.78001 21.115Z" fill="currentColor"/>
                                                        <path d="M21.7 8.08899L15.911 2.30005C15.8161 2.2049 15.7033 2.12939 15.5792 2.07788C15.455 2.02637 15.3219 1.99988 15.1875 1.99988C15.0531 1.99988 14.92 2.02637 14.7958 2.07788C14.6717 2.12939 14.5589 2.2049 14.464 2.30005L13.74 3.02295C13.548 3.21498 13.4402 3.4754 13.4402 3.74695C13.4402 4.01849 13.548 4.27892 13.74 4.47095L14.464 5.19397L11.303 8.35498C10.1615 7.80702 8.87825 7.62639 7.62985 7.83789C6.38145 8.04939 5.2293 8.64265 4.332 9.53601C4.14026 9.72817 4.03256 9.98855 4.03256 10.26C4.03256 10.5315 4.14026 10.7918 4.332 10.984L13.016 19.667C13.208 19.859 13.4684 19.9668 13.74 19.9668C14.0115 19.9668 14.272 19.859 14.464 19.667C15.3575 18.77 15.9509 17.618 16.1624 16.3698C16.374 15.1215 16.1932 13.8383 15.645 12.697L18.806 9.53601L19.529 10.26C19.721 10.452 19.9814 10.5598 20.253 10.5598C20.5245 10.5598 20.785 10.452 20.977 10.26L21.7 9.53601C21.7952 9.44108 21.8706 9.32825 21.9221 9.2041C21.9737 9.07995 22.0002 8.94691 22.0002 8.8125C22.0002 8.67809 21.9737 8.54505 21.9221 8.4209C21.8706 8.29675 21.7952 8.18392 21.7 8.08899Z" fill="currentColor"/>
                                                        </svg>
                                                        </span>
                                                    </span> 
                                                    <span class="d-flex flex-column">
                                                        <span class="fs-6 fw-bold text-gray-800">
                                                            <router-link class="menu-link py-3" :to="{ name: 'CompanyOverview' }">
                                                                Company Profile
                                                            </router-link>
                                                        </span> 
                                                    </span>  
                                                </a>
                                            </div>
                                            <div class="menu-item p-0 m-0">
                                                <a href="#" class="menu-link">
                                                  <span class="menu-custom-icon d-flex flex-center flex-shrink-0 rounded w-40px h-40px me-3">
                                                    <span class="svg-icon svg-icon-info svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.3" d="M10 4H21C21.6 4 22 4.4 22 5V7H10V4Z" fill="currentColor"/>
                                                    <path opacity="0.3" d="M10.3 15.3L11 14.6L8.70002 12.3C8.30002 11.9 7.7 11.9 7.3 12.3C6.9 12.7 6.9 13.3 7.3 13.7L10.3 16.7C9.9 16.3 9.9 15.7 10.3 15.3Z" fill="currentColor"/>
                                                    <path d="M10.4 3.60001L12 6H21C21.6 6 22 6.4 22 7V19C22 19.6 21.6 20 21 20H3C2.4 20 2 19.6 2 19V4C2 3.4 2.4 3 3 3H9.20001C9.70001 3 10.2 3.20001 10.4 3.60001ZM11.7 16.7L16.7 11.7C17.1 11.3 17.1 10.7 16.7 10.3C16.3 9.89999 15.7 9.89999 15.3 10.3L11 14.6L8.70001 12.3C8.30001 11.9 7.69999 11.9 7.29999 12.3C6.89999 12.7 6.89999 13.3 7.29999 13.7L10.3 16.7C10.5 16.9 10.8 17 11 17C11.2 17 11.5 16.9 11.7 16.7Z" fill="currentColor"/>
                                                    </svg>
                                                    </span>
                                                  </span>
                                                    <span class="d-flex flex-column"> 
                                                        <span class="fs-6 fw-bold text-gray-800">
                                                            <router-link class="menu-link py-3" :to="{ name: 'CompanyDocuments' }">
                                                                Documents
                                                            </router-link>
                                                        </span> 
                                                    </span>  
                                                </a>
                                            </div>
                                            <div class="menu-item p-0 m-0">
                                                <a href="#" class="menu-link">
                                                    <span class="menu-custom-icon d-flex flex-center flex-shrink-0 rounded w-40px h-40px me-3"> 
                                                       <span class="svg-icon svg-icon-muted svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path opacity="0.3" d="M22.9558 10.2848L21.3341 8.6398C21.221 8.52901 21.1317 8.39637 21.0715 8.24996C21.0114 8.10354 20.9816 7.94641 20.9841 7.78814V5.4548C20.9826 5.13514 20.9179 4.81893 20.7938 4.52433C20.6697 4.22973 20.4887 3.96255 20.261 3.73814C20.0333 3.51374 19.7636 3.33652 19.4672 3.21668C19.1709 3.09684 18.8538 3.03673 18.5341 3.0398H16.2008C16.0425 3.04229 15.8854 3.01255 15.739 2.95238C15.5925 2.89221 15.4599 2.80287 15.3491 2.6898L13.7158 1.0448C13.2608 0.590273 12.6439 0.334961 12.0008 0.334961C11.3576 0.334961 10.7408 0.590273 10.2858 1.0448L8.64078 2.66647C8.52999 2.77954 8.39735 2.86887 8.25094 2.92904C8.10452 2.98922 7.94739 3.01896 7.78911 3.01647H5.45578C5.13612 3.01799 4.8199 3.08266 4.5253 3.20675C4.23071 3.33085 3.96353 3.51193 3.73912 3.73959C3.51471 3.96724 3.3375 4.237 3.21766 4.53335C3.09781 4.82971 3.0377 5.14682 3.04078 5.46647V7.7998C3.04327 7.95808 3.01353 8.11521 2.95335 8.26163C2.89318 8.40804 2.80385 8.54068 2.69078 8.65147L1.04578 10.2848C0.591249 10.7398 0.335938 11.3567 0.335938 11.9998C0.335938 12.6429 0.591249 13.2598 1.04578 13.7148L2.66745 15.3598C2.78051 15.4706 2.86985 15.6032 2.93002 15.7496C2.99019 15.8961 3.01994 16.0532 3.01745 16.2115V18.5448C3.01897 18.8645 3.08363 19.1807 3.20773 19.4753C3.33182 19.7699 3.5129 20.0371 3.74056 20.2615C3.96822 20.4859 4.23798 20.6631 4.53433 20.7829C4.83068 20.9028 5.14779 20.9629 5.46745 20.9598H7.80078C7.95906 20.9573 8.11619 20.9871 8.2626 21.0472C8.40902 21.1074 8.54166 21.1967 8.65245 21.3098L10.2974 22.9548C10.7525 23.4093 11.3693 23.6646 12.0124 23.6646C12.6556 23.6646 13.2724 23.4093 13.7274 22.9548L15.3608 21.3331C15.4716 21.2201 15.6042 21.1307 15.7506 21.0706C15.897 21.0104 16.0542 20.9806 16.2124 20.9831H18.5458C19.1894 20.9831 19.8066 20.7275 20.2617 20.2724C20.7168 19.8173 20.9724 19.2001 20.9724 18.5565V16.2231C20.97 16.0649 20.9997 15.9077 21.0599 15.7613C21.12 15.6149 21.2094 15.4823 21.3224 15.3715L22.9674 13.7265C23.1935 13.5002 23.3726 13.2314 23.4944 12.9357C23.6162 12.64 23.6784 12.3231 23.6773 12.0032C23.6762 11.6834 23.6119 11.3669 23.4881 11.072C23.3643 10.7771 23.1834 10.5095 22.9558 10.2848Z" fill="currentColor"/>
                                                        <path d="M12.0039 15.4998C11.7012 15.4998 11.4109 15.38 11.1969 15.1668C10.9829 14.9535 10.8626 14.6643 10.8626 14.3627V13.9382C10.8467 13.2884 10.9994 12.6456 11.306 12.0718C11.6126 11.4981 12.0627 11.013 12.6126 10.6634C12.7969 10.561 12.9505 10.4114 13.0575 10.2302C13.1645 10.049 13.221 9.84266 13.2213 9.63242C13.2213 9.31073 13.0931 9.00223 12.8648 8.77476C12.6365 8.5473 12.3268 8.41951 12.0039 8.41951C11.6811 8.41951 11.3714 8.5473 11.1431 8.77476C10.9148 9.00223 10.7865 9.31073 10.7865 9.63242C10.7865 9.93399 10.6663 10.2232 10.4523 10.4365C10.2382 10.6497 9.94792 10.7695 9.64522 10.7695C9.34253 10.7695 9.05223 10.6497 8.83819 10.4365C8.62415 10.2232 8.50391 9.93399 8.50391 9.63242C8.50763 9.02196 8.67214 8.42317 8.98099 7.89592C9.28984 7.36868 9.7322 6.93145 10.2639 6.62796C10.7955 6.32447 11.3978 6.16535 12.0105 6.16651C12.6233 6.16767 13.225 6.32908 13.7554 6.63458C14.2859 6.94009 14.7266 7.37899 15.0335 7.9074C15.3403 8.43582 15.5025 9.03522 15.5039 9.64569C15.5053 10.2562 15.3458 10.8563 15.0414 11.3861C14.7369 11.9159 14.2983 12.3568 13.7692 12.6647C13.5645 12.8132 13.4003 13.0101 13.2913 13.2378C13.1824 13.4655 13.1322 13.7167 13.1453 13.9685V14.3931C13.1373 14.6894 13.0136 14.9708 12.8004 15.1776C12.5872 15.3843 12.3014 15.4999 12.0039 15.4998Z" fill="currentColor"/>
                                                        <path d="M12.0026 18.9998C12.6469 18.9998 13.1693 18.4775 13.1693 17.8332C13.1693 17.1888 12.6469 16.6665 12.0026 16.6665C11.3583 16.6665 10.8359 17.1888 10.8359 17.8332C10.8359 18.4775 11.3583 18.9998 12.0026 18.9998Z" fill="currentColor"/>
                                                        </svg>
                                                        </span>
                                                    </span>  
                                                    <span class="d-flex flex-column"> 
                                                         <span class="fs-6 fw-bold text-gray-800">
                                                            <router-link class="menu-link py-3" :to="{ name: 'Liabilities' }">
                                                                Liabilities
                                                            </router-link>
                                                        </span> 
                                                    </span> 
                                                </a>
                                            </div>
                                        </div>
                                    </div> 
                                </div> 
                            </div>
                        </div> 
                    </div> 
                </div>
            </div>
            <div data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-placement="bottom-start" class="menu-item menu-lg-down-accordion me-0 me-lg-2">
              <span class="menu-link py-3">
                <span class="menu-title">Accounting</span>
                <span class="menu-arrow d-lg-none"></span>
              </span> 
              <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown p-0 w-100 w-lg-300px" style="">
                  <div class="menu-state-bg menu-extended"> 
                      <div class="row">
                          <div class="col-lg-12 mb-3 mb-lg-0 py-3 px-3 py-lg-6 px-lg-6">
                              <div class="row">
                                  <div class="col-lg-12 mb-3">
                                    <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion"> 
                                      <div class="menu-item p-0 m-0">
                                          <a href="#" class="menu-link">
                                              <span class="menu-custom-icon d-flex flex-center flex-shrink-0 rounded w-40px h-40px me-3"> 
                                                  <span class="svg-icon svg-icon-danger svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path opacity="0.3" d="M20 15H4C2.9 15 2 14.1 2 13V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V13C22 14.1 21.1 15 20 15ZM13 12H11C10.5 12 10 12.4 10 13V16C10 16.5 10.4 17 11 17H13C13.6 17 14 16.6 14 16V13C14 12.4 13.6 12 13 12Z" fill="currentColor"/>
                                                  <path d="M14 6V5H10V6H8V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V6H14ZM20 15H14V16C14 16.6 13.5 17 13 17H11C10.5 17 10 16.6 10 16V15H4C3.6 15 3.3 14.9 3 14.7V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V14.7C20.7 14.9 20.4 15 20 15Z" fill="currentColor"/>
                                                  </svg>
                                                  </span>
                                              </span> 
                                              <span class="d-flex flex-column">
                                                  <span class="fs-6 fw-bold text-gray-800">Accounting Transaction</span>
                                                  <span class="fs-7 fw-semibold text-muted">View Accounting Transactions</span>
                                              </span> 
                                            <span class="menu-arrow" style="position:absolute; right: 15px;"></span>
                                          </a>
                                      </div>
                                      <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg px-lg-2 py-lg-4 w-lg-225px">
                                          <div class="menu-item">
                                          <router-link :to="{ name: 'AccountingVoucherList' }">
                                                <a class="menu-link py-3 cursor-pointer" href="">
                                                    <span class="menu-bullet">
                                                        <span class="bullet bullet-dot"></span>
                                                    </span>
                                                    <span class="menu-title">Accounting Voucher Operations</span>
                                                </a>
                                              </router-link>
                                          </div> 
                                          <div class="menu-item">
                                            <router-link :to="{ name: 'VATOperationsList' }">
                                                <a class="menu-link py-3 cursor-pointer" href="">
                                                    <span class="menu-bullet">
                                                        <span class="bullet bullet-dot"></span>
                                                    </span>
                                                    <span class="menu-title">VAT Operations </span>
                                                </a>
                                              </router-link>
                                          </div> 
                                          <div class="menu-item">
                                              <router-link :to="{ name: 'OpeningOperationsList' }">
                                                <a class="menu-link py-3 cursor-pointer" href="">
                                                    <span class="menu-bullet">
                                                        <span class="bullet bullet-dot"></span>
                                                    </span>
                                                    <span class="menu-title">Opening Operations</span>
                                                </a>
                                              </router-link>
                                          </div> 
                                          <div class="menu-item">
                                              <router-link :to="{ name: 'ProfitAndLossOperationsList' }">
                                                <a class="menu-link py-3 cursor-pointer" href="">
                                                    <span class="menu-bullet">
                                                        <span class="bullet bullet-dot"></span>
                                                    </span>
                                                    <span class="menu-title">Profit & Loss Operations</span>
                                                </a>
                                              </router-link>
                                          </div> 
                                          <div class="menu-item">
                                              <router-link :to="{ name: 'ClosingOperationsList' }">
                                                <a class="menu-link py-3 cursor-pointer" href="">
                                                    <span class="menu-bullet">
                                                        <span class="bullet bullet-dot"></span>
                                                    </span>
                                                    <span class="menu-title">Closing Operations</span>
                                                </a>
                                              </router-link>
                                          </div> 
                                      </div>
                                    </div>
                                  </div>
                                   <div class="separator separator-dashed mx-3 mt-0 mb-3"></div>
                                  <div class="col-lg-12 mb-3">
                                    <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion"> 
                                      <div class="menu-item p-0 m-0">
                                          <a href="#" class="menu-link">                                              
                                              <span class="menu-custom-icon d-flex flex-center flex-shrink-0 rounded w-40px h-40px me-3"> 
                                                  <span class="svg-icon svg-icon-info svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path d="M13 5.91517C15.8 6.41517 18 8.81519 18 11.8152C18 12.5152 17.9 13.2152 17.6 13.9152L20.1 15.3152C20.6 15.6152 21.4 15.4152 21.6 14.8152C21.9 13.9152 22.1 12.9152 22.1 11.8152C22.1 7.01519 18.8 3.11521 14.3 2.01521C13.7 1.91521 13.1 2.31521 13.1 3.01521V5.91517H13Z" fill="currentColor"/>
                                                  <path opacity="0.3" d="M19.1 17.0152C19.7 17.3152 19.8 18.1152 19.3 18.5152C17.5 20.5152 14.9 21.7152 12 21.7152C9.1 21.7152 6.50001 20.5152 4.70001 18.5152C4.30001 18.0152 4.39999 17.3152 4.89999 17.0152L7.39999 15.6152C8.49999 16.9152 10.2 17.8152 12 17.8152C13.8 17.8152 15.5 17.0152 16.6 15.6152L19.1 17.0152ZM6.39999 13.9151C6.19999 13.2151 6 12.5152 6 11.8152C6 8.81517 8.2 6.41515 11 5.91515V3.01519C11 2.41519 10.4 1.91519 9.79999 2.01519C5.29999 3.01519 2 7.01517 2 11.8152C2 12.8152 2.2 13.8152 2.5 14.8152C2.7 15.4152 3.4 15.7152 4 15.3152L6.39999 13.9151Z" fill="currentColor"/>
                                                  </svg>
                                                  </span>
                                              </span>  
                                              <span class="d-flex flex-column">
                                                  <span class="fs-6 fw-bold text-gray-800">Balance-Sheet</span>
                                                  <span class="fs-7 fw-semibold text-muted">View Balance-Sheet</span>
                                              </span> 
                                            <span class="menu-arrow" style="position:absolute; right: 15px;"></span>
                                          </a>
                                      </div>
                                      <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg px-lg-2 py-lg-4 w-lg-225px">
                                          <div class="menu-item">
                                          <router-link :to="{ name: 'BalanceSheetList' }">
                                                <a class="menu-link py-3 cursor-pointer" href="">
                                                    <span class="menu-bullet">
                                                        <span class="bullet bullet-dot"></span>
                                                    </span>
                                                    <span class="menu-title">General Balance-Sheet</span>
                                                </a>
                                              </router-link>
                                          </div> 
                                          <div class="menu-item">
                                              <router-link :to="{ name: 'ComparativeBalanceSheetList' }">
                                                <a class="menu-link py-3 cursor-pointer" href="">
                                                    <span class="menu-bullet">
                                                        <span class="bullet bullet-dot"></span>
                                                    </span>
                                                    <span class="menu-title">Comparative Balance-Sheet</span>
                                                </a>
                                              </router-link>
                                          </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-lg-12 mb-3">
                                    <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion"> 
                                      <div class="menu-item p-0 m-0">
                                          <a href="#" class="menu-link position-relative">
                                              <span class="menu-custom-icon d-flex flex-center flex-shrink-0 rounded w-40px h-40px me-3"> 
                                                  <span class="svg-icon svg-icon-cyan svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path d="M13 5.91517C15.8 6.41517 18 8.81519 18 11.8152C18 12.5152 17.9 13.2152 17.6 13.9152L20.1 15.3152C20.6 15.6152 21.4 15.4152 21.6 14.8152C21.9 13.9152 22.1 12.9152 22.1 11.8152C22.1 7.01519 18.8 3.11521 14.3 2.01521C13.7 1.91521 13.1 2.31521 13.1 3.01521V5.91517H13Z" fill="currentColor"/>
                                                  <path opacity="0.3" d="M19.1 17.0152C19.7 17.3152 19.8 18.1152 19.3 18.5152C17.5 20.5152 14.9 21.7152 12 21.7152C9.1 21.7152 6.50001 20.5152 4.70001 18.5152C4.30001 18.0152 4.39999 17.3152 4.89999 17.0152L7.39999 15.6152C8.49999 16.9152 10.2 17.8152 12 17.8152C13.8 17.8152 15.5 17.0152 16.6 15.6152L19.1 17.0152ZM6.39999 13.9151C6.19999 13.2151 6 12.5152 6 11.8152C6 8.81517 8.2 6.41515 11 5.91515V3.01519C11 2.41519 10.4 1.91519 9.79999 2.01519C5.29999 3.01519 2 7.01517 2 11.8152C2 12.8152 2.2 13.8152 2.5 14.8152C2.7 15.4152 3.4 15.7152 4 15.3152L6.39999 13.9151Z" fill="currentColor"/>
                                                  </svg>
                                                  </span>
                                              </span>  
                                              <span class="d-flex flex-column">
                                                  <span class="fs-6 fw-bold text-gray-800">Profit & Loss Statements</span>
                                                  <span class="fs-7 fw-semibold text-muted">View Profit & Loss Statements</span>
                                              </span> 
                                            <span class="menu-arrow" style="position:absolute; right: 15px;"></span>
                                          </a>
                                      </div>
                                      <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg px-lg-2 py-lg-4 w-lg-225px">
                                          <div class="menu-item">
                                          <router-link :to="{ name: 'GeneralProfitAndLossList' }">
                                                <a class="menu-link py-3 cursor-pointer" href="">
                                                    <span class="menu-bullet">
                                                        <span class="bullet bullet-dot"></span>
                                                    </span>
                                                    <span class="menu-title">General Profit & Loss</span>
                                                </a>
                                              </router-link>
                                          </div> 
                                          <div class="menu-item">
                                              <router-link :to="{ name: 'ComparativeProfitAndLossList' }">
                                                <a class="menu-link py-3 cursor-pointer" href="">
                                                    <span class="menu-bullet">
                                                        <span class="bullet bullet-dot"></span>
                                                    </span>
                                                    <span class="menu-title">Comparative Profit & Loss</span>
                                                </a>
                                              </router-link>
                                          </div>
                                      </div>
                                    </div>
                                  </div> 
                              </div> 
                          </div>
                      </div> 
                  </div> 
              </div>
            </div>
          </div> 
          <div class="d-flex align-items-stretch flex-shrink-0 p-4 p-lg-0 me-lg-2" id="kt_header_search_wrapper"  v-if="this.selectedCompany.instant_access == 1 && this.selectedCompany.is_active == 1">
            <div class="menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch flex-grow-1" id="#kt_header_menu"
            data-kt-menu="true">
            <div class="menu-item me-lg-1">
              <span class="menu-link py-3 cursor-pointer" @click="onInstantLogin(this.selectedCompany)">
                <span class="menu-title">
                  <i class="bi bi-box-arrow-right fs-2"></i>
                </span>
                <span class="menu-arrow d-lg-none"></span>
              </span>
            </div>
            </div>
          </div>
          <div class="d-flex align-items-stretch flex-shrink-0 p-4 p-lg-0 me-lg-2" id="kt_header_search_wrapper">
            <div class="menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch flex-grow-1" id="#kt_header_menu"
            data-kt-menu="true">
              <div class="menu-item me-lg-1" @click="openChatBi(null, this.selectedCompany.id)" data-bs-toggle="modal" data-bs-target="#chatbi_modal">
                <span class="menu-link py-3">
                  <span class="menu-title">
                    <span class="svg-icon svg-icon-success svg-icon-2x"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.3" d="M8 8C8 7.4 8.4 7 9 7H16V3C16 2.4 15.6 2 15 2H3C2.4 2 2 2.4 2 3V13C2 13.6 2.4 14 3 14H5V16.1C5 16.8 5.79999 17.1 6.29999 16.6L8 14.9V8Z" fill="currentColor"/>
                    <path d="M22 8V18C22 18.6 21.6 19 21 19H19V21.1C19 21.8 18.2 22.1 17.7 21.6L15 18.9H9C8.4 18.9 8 18.5 8 17.9V7.90002C8 7.30002 8.4 6.90002 9 6.90002H21C21.6 7.00002 22 7.4 22 8ZM19 11C19 10.4 18.6 10 18 10H12C11.4 10 11 10.4 11 11C11 11.6 11.4 12 12 12H18C18.6 12 19 11.6 19 11ZM17 15C17 14.4 16.6 14 16 14H12C11.4 14 11 14.4 11 15C11 15.6 11.4 16 12 16H16C16.6 16 17 15.6 17 15Z" fill="currentColor"/>
                    </svg>
                    </span>
                  </span>
                  <span class="menu-arrow d-lg-none"></span>
                </span>
              </div>
              <span class="badge badge-circle badge-danger badge-sm" v-if="unReadCompanyMessageCount > 0">
                {{ unReadCompanyMessageCount }}
              </span> 
            </div>
          </div>
          <div class="d-flex align-items-stretch flex-shrink-0 p-4 p-lg-0 me-lg-2" id="kt_header_search_wrapper">
            <div class="menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch flex-grow-1" id="#kt_header_menu"
            data-kt-menu="true">
              <div class="menu-item me-lg-1" @click="openCompanyAccountUpdate()">
                <span class="menu-link py-3">
                  <span class="menu-title">
                    <i class="bi bi-pencil-square fs-2"></i> 
                  </span>
                  <span class="menu-arrow d-lg-none"></span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="kt_modal_select_company" tabindex="-1" role="dialog" aria-modal="true" style="display: none;"  data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content modal-rounded"  >
            <div class="modal-header bg-secondary">
              <h2>Your Companies <span v-if="userData.controller_account_name !== '' && userData.controller_account_name !== null"> - ({{userData.controller_account_name}}) </span> </h2>
              <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" ref="Close">
                <span class="svg-icon svg-icon-1">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                  </svg>
                </span>
              </div>
            </div>
            <div class="modal-body scroll-y p-0">
              <div class="card">
                <div class="card-header">
                    <div class="card-title">
                        <div class="d-flex align-items-center position-relative my-1">
                            <span class="svg-icon svg-icon-1 position-absolute ms-6">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor"></rect>
                                    <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="currentColor"></path>
                                </svg>
                            </span>
                            
                            <input type="text" data-kt-customer-table-filter="search" class="form-control form-control-solid w-250px ps-15 form-control-sm" placeholder="Search in companies" v-model="searchbar">
                        </div>
                    </div>           
                </div> 
                <div class="card-body pt-0">
                  <div class="table-responsive mh-350px ">
                    <table id="kt_profile_overview_table" class="table table-row-bordered table-row-dashed gy-4 align-middle fw-bold dataTable no-footer">
                      <thead class="fs-7 text-gray-400 text-uppercase">
                        <tr>
                        <th class="min-w-250px">Company Name <br> Code</th>
                        <th class="min-w-150px">Company <br> Type</th>
                        <th class="min-w-90px">Country</th>
                        <th class="min-w-90px">Primary Person <br> Director </th>
                        <th class="min-w-50px text-end"></th>
                      </tr>
                      </thead>
                      <tbody class="fs-6" v-if="companyAccounts">
                        <tr class="odd" v-for="item in searchableCompanyAccountList" v-bind:key="item">
                          
                          <td>
                            <div class="d-flex align-items-center">
                              <div class="me-5 position-relative">
                                <div class="symbol symbol-35px symbol-circle">
                                  <img alt="Pic" src="assets/theme/media/avatars/blank.png">
                                </div>
                              </div>
                              <div class="d-flex flex-column justify-content-center">
                                <a href="" class="fs-6 text-gray-800 text-hover-primary">{{item.text}}</a>
                                <div class="fw-semibold text-gray-400">{{item.company_vkn}}</div>
                              </div>
                            </div>
                          </td>
                          <td class="text-gray-800">{{item.company_type_name}}</td>
                          <td class="text-gray-800">{{item.company_country_code}}</td>
                          <td class="text-gray-800">
                            {{item.primary_person}}
                          </td>
                          <td class="text-end">
                            <a href="#" class="btn btn-light-success border border-success btn-sm" @click="onSelectCompany(item)">Select</a>
                          </td>
                        </tr>
                        </tbody>
                    </table>
                  </div>
                </div>  
              </div>
            </div>
          </div>
        </div>
    </div>

    <div class="modal fade" id="kt_modal_create_company" style="display: none;" aria-modal="true" role="dialog">
			<div class="modal-dialog modal-xl p-9">
				<div class="modal-content modal-rounded">
					<div class="modal-header py-7 d-flex justify-content-between">
						<h2>Create a new company <span v-if="userData.controller_account_name !== '' && userData.controller_account_name !== null"> - ({{userData.controller_account_name}}) </span></h2>
						<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
							<span class="svg-icon svg-icon-1">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
									<rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
								</svg>
							</span>
						</div>
					</div>
					<div class="modal-body scroll-y m-5">
						<div class="stepper stepper-links d-flex flex-column" data-kt-stepper="true">
							<div class="stepper-nav justify-content-center py-2">
								<div class="stepper-item me-5 me-md-15" data-kt-stepper-element="nav" :class="{'current': this.activeStep == 1}">
									<h3 class="stepper-title">1</h3>
								</div>
								<div class="stepper-item me-5 me-md-15" data-kt-stepper-element="nav" :class="{'current': this.activeStep == 2}">
									<h3 class="stepper-title">2</h3>
								</div>
								<div class="stepper-item me-5 me-md-15" data-kt-stepper-element="nav" :class="{'current': this.activeStep == 3}">
									<h3 class="stepper-title">3</h3>
								</div>
								<div class="stepper-item me-5 me-md-15" data-kt-stepper-element="nav" :class="{'current': this.activeStep == 4}">
									<h3 class="stepper-title">4</h3>
								</div>
								<div class="stepper-item" data-kt-stepper-element="nav" :class="{'current': this.activeStep == 5}">
									<h3 class="stepper-title">5</h3>
								</div>
								<div class="stepper-item" data-kt-stepper-element="nav" :class="{'current': this.activeStep == 6}">
									<h3 class="stepper-title">6</h3>
								</div>
							</div>
							<form class="mx-auto w-100 mw-600px pt-15 pb-10 fv-plugins-bootstrap5 fv-plugins-framework" novalidate="novalidate">
								<div class="current" data-kt-stepper-element="content" v-if="this.activeStep == 1">
									<div class="w-100">
										<div class="pb-10 pb-lg-15">
											<h2 class="fw-bold d-flex align-items-center text-gray-800">Setup Campaign Details 
											<i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip" aria-label="Campaign name will be used as reference within your campaign reports" data-kt-initialized="1"></i></h2>
											<div class="text-muted fw-semibold fs-6">If you need more info, please check out 
											<a href="#" class="link-primary fw-bold">Help Page</a>.</div>
										</div>                    
                    <div class="fv-row row">
                       <div class="col-lg-6">
                          <label class="required form-label mt-3">Country</label>
                          <input type="text" class="form-control form-control-lg form-control-solid" name="campaign_name" placeholder="" value="">
                       </div>
                       <div class="col-lg-6">
                          <label class="required form-label mt-3">Currency</label>
                          <input type="text" class="form-control form-control-lg form-control-solid" name="campaign_name" placeholder="" value="">
                        </div>                      
                       <div class="col-lg-12">
                          <label class="required form-label mt-3">Company Type</label>
                          <input type="text" class="form-control form-control-lg form-control-solid" name="campaign_name" placeholder="" value="">
                        </div>                      
                       <div class="col-lg-12">
                          <label class="required form-label mt-3">Business Type</label>
                          <input type="text" class="form-control form-control-lg form-control-solid" name="campaign_name" placeholder="" value="">
                        </div>                      
                       <div class="col-lg-12">
                          <label class="required form-label mt-3">Sector</label>
                          <input type="text" class="form-control form-control-lg form-control-solid" name="campaign_name" placeholder="" value="">
                        </div>                      
                    </div>
									</div>
								</div>
								<div  v-if="this.activeStep == 2">
									<div class="w-100">
										<div class="fv-row row">
                       <div class="col-lg-12">
                          <label class="required form-label mt-3">Company Number</label>
                          <div class="input-group">
                          <input type="text" class="form-control form-control-lg form-control-solid" name="campaign_name" placeholder="" value="">
                            <button type="button" class="btn btn-secondary" id="basic-addon2">
                              <i class="fas fa-search fs-4 me-3"></i> Search 
                            </button>
                          </div>
                       </div>                     
                       <div class="col-lg-12">
                          <label class="required form-label mt-3">Company Name</label>
                          <input type="text" class="form-control form-control-lg form-control-solid" name="campaign_name" placeholder="" value="">
                       </div>                     
                       <div class="col-lg-12">
                          <label class="required form-label mt-3">Primary Person Name</label>
                          <input type="text" class="form-control form-control-lg form-control-solid" name="campaign_name" placeholder="" value="">
                       </div>                     
                       <div class="col-lg-12">
                          <label class="required form-label mt-3">Primary Person EMail</label>
                          <input type="text" class="form-control form-control-lg form-control-solid" name="campaign_name" placeholder="" value="">
                       </div>                     
                       <div class="col-lg-12">
                          <label class="required form-label mt-3">Primary Person Mobile</label>
                          <input type="text" class="form-control form-control-lg form-control-solid" name="campaign_name" placeholder="" value="">
                       </div>                     
                    </div>
									</div>
								</div>
								<div v-if="this.activeStep == 3">
									<div class="w-100">
										<div class="fv-row row">
                       <div class="col-lg-12">
                          <label class="required form-label mt-3">Post Code</label>
                          <div class="input-group">
                          <input type="text" class="form-control form-control-lg form-control-solid" name="campaign_name" placeholder="" value="">
                            <button type="button" class="btn btn-secondary" id="basic-addon2">
                              <i class="fas fa-search fs-4 me-3"></i> Search 
                            </button>
                          </div>
                       </div>                     
                       <div class="col-lg-12">
                          <label class="required form-label mt-3">Address List</label>
                          <input type="text" class="form-control form-control-lg form-control-solid" name="campaign_name" placeholder="" value="">
                       </div>                     
                       <div class="col-lg-12">
                          <label class="required form-label mt-3">Address</label>
                          <textarea rows="3" type="text" class="form-control form-control-lg form-control-solid" name="campaign_name" placeholder="" value=""> </textarea>
                       </div>                     
                       <div class="col-lg-12">
                          <label class="required form-label mt-3">City</label>
                          <input type="text" class="form-control form-control-lg form-control-solid" name="campaign_name" placeholder="" value="">
                       </div>                   
                    </div>
									</div>
								</div>
								<div v-if="this.activeStep == 4">
									<div class="w-100">
										<div class="fv-row mb-10">
											<label class="fs-6 fw-semibold mb-2">Do you use Accounting Plan? 
											<i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip" aria-label="Show your ads to either men or women, or select 'All' for both" data-kt-initialized="1"></i></label>
											<div class="row g-9" data-kt-buttons="true" data-kt-buttons-target="[data-kt-button='true']" data-kt-initialized="1">
												<div class="col">
													<label class="btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6" data-kt-button="true">
														<span class="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
															<input class="form-check-input" type="radio" name="campaign_gender" value="2">
														</span>
														<span class="ms-5">
															<span class="fs-4 fw-bold text-gray-800 d-block">Yes</span>
														</span>
													</label>
												</div>
												<div class="col">
													<label class="btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6 active" data-kt-button="true">
														<span class="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
															<input class="form-check-input" type="radio" name="campaign_gender" value="3">
														</span>
														<span class="ms-5">
															<span class="fs-4 fw-bold text-gray-800 d-block">No</span>
														</span>
													</label>
												</div>
											</div>
                      <div class="fv-row row mt-4">
                        <div class="col-lg-4"> 
                            <label class="fs-6 fw-bold form-label mb-2">Incorporated Day</label>
                            <Datepicker textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.start_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'"></Datepicker>  
                        </div>
                        <div class="col-lg-4"> 
                            <label class="fs-6 fw-bold form-label mb-2">Accounting Start Period</label>
                            <Datepicker textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.start_date" inputClassName="form-control" format="dd MMM" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" :flow="['month', 'calendar']"></Datepicker>  
                        </div>
                        <div class="col-lg-4">
                            <label class="fs-6 fw-bold form-label mb-2">Accounting End Period</label>
                            <Datepicker textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.start_date" inputClassName="form-control" format="dd MMM" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" :flow="['month', 'calendar']"></Datepicker>  
                        </div>
                      </div> 

                      <label class="fs-6 fw-semibold mb-2">Do you have VAT Account? 
											<i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip" aria-label="Show your ads to either men or women, or select 'All' for both" data-kt-initialized="1"></i></label>
											<div class="row g-9" data-kt-buttons="true" data-kt-buttons-target="[data-kt-button='true']" data-kt-initialized="1">
												<div class="col">
													<label class="btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6" data-kt-button="true">
														<span class="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
															<input class="form-check-input" type="radio" name="campaign_gender" value="2">
														</span>
														<span class="ms-5">
															<span class="fs-4 fw-bold text-gray-800 d-block">Yes</span>
														</span>
													</label>
												</div>
												<div class="col">
													<label class="btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6 active" data-kt-button="true">
														<span class="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
															<input class="form-check-input" type="radio" name="campaign_gender" value="3">
														</span>
														<span class="ms-5">
															<span class="fs-4 fw-bold text-gray-800 d-block">No</span>
														</span>
													</label>
												</div>
											</div>

                      <div class="fv-row row mt-4">
                        <div class="col-lg-12">
                              <label class="fs-6 fw-bold form-label mb-2 required">
                                VAT Number
                              </label>
                              <input type="text" class="form-control" placeholder="" name="name" v-model="form.company_vat_number"> 
                            </div>
                      </div>
										</div>
									</div>
								</div>
								<div v-if="this.activeStep == 5">
									<div class="w-100">
										<div class="pb-12 text-center">
											<h1 class="fw-bold text-gray-800">Payment Parameters</h1>
											<div class="fw-semibold text-muted fs-4">You will receive an email with with the summary of your newly created campaign!</div>
										</div>
									</div>
								</div>
								<div v-if="this.activeStep == 6">
									<div class="w-100">
										<div class="pb-12 text-center">
											<h1 class="fw-bold text-gray-800">Campaign Created!</h1>
											<div class="fw-semibold text-muted fs-4">You will receive an email with with the summary of your newly created campaign!</div>
										</div>
										<div class="d-flex flex-center pb-20">
											<button id="kt_modal_create_campaign_create_new" type="button" class="btn btn-lg btn-light me-3" data-kt-element="complete-start">Create New Campaign</button>
											<a href="" class="btn btn-lg btn-primary" data-bs-toggle="tooltip" data-kt-initialized="1">View Campaign</a>
										</div>
										<div class="text-center px-4">
											<img src="/metronic8/demo16/assets/media/illustrations/sketchy-1/9.png" alt="" class="mww-100 mh-350px">
										</div>
									</div>
								</div>
								<div class="d-flex flex-stack pt-10">
									<div class="me-2">
										<button type="button" class="btn btn-lg btn-light-primary me-3" v-if="this.activeStep !== 1" @click="onBackStep()">
										<span class="svg-icon svg-icon-3 me-1">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect opacity="0.5" x="6" y="11" width="13" height="2" rx="1" fill="currentColor"></rect>
												<path d="M8.56569 11.4343L12.75 7.25C13.1642 6.83579 13.1642 6.16421 12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75L5.70711 11.2929C5.31658 11.6834 5.31658 12.3166 5.70711 12.7071L11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25C13.1642 17.8358 13.1642 17.1642 12.75 16.75L8.56569 12.5657C8.25327 12.2533 8.25327 11.7467 8.56569 11.4343Z" fill="currentColor"></path>
											</svg>
										</span>
                    Back</button>
									</div>
									<div>
										<button type="button" class="btn btn-lg btn-success" v-if="this.activeStep == 5" @click="onNextStep()">
											<span class="indicator-label">Submit 
											<span class="svg-icon svg-icon-3 ms-2 me-0">
												<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
													<rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="currentColor"></rect>
													<path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="currentColor"></path>
												</svg>
											</span>
                      </span>
											<span class="indicator-progress">Please wait... 
											<span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
										</button>
										<button type="button" class="btn btn-lg btn-primary" v-if="this.activeStep !== 5 && this.activeStep !== 6" @click="onNextStep()">Continue 
										<span class="svg-icon svg-icon-3 ms-1 me-0">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="currentColor"></rect>
												<path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="currentColor"></path>
											</svg>
										</span>
                    </button>
										<button type="button" class="btn btn-lg btn-primary" v-if="this.activeStep == 6" @click="onNextStep()">Create a new Company Account
										<span class="svg-icon svg-icon-3 ms-1 me-0">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="currentColor"></rect>
												<path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="currentColor"></path>
											</svg>
										</span>
                    </button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>    
    <!-- CONTROLLER ACCESS NOTIFICATION -->
    <div class="bg-light-warning pt-3 pb-3 fs-7 text-gray-900 border border-warning" v-if="userData.controller_account_id !== null && userData.controller_account_id !== '' && userData.controller_account_id !== undefined && userData.account_type != 2"> 
      <div class="container">
        <i class="bi bi-check2-all fs-2 text-primary"></i> You are logged in by inheriting Controller (<strong> {{ userData.controller_account_name }}</strong>) privileges. 
      </div>
    </div>
    <!-- ChatBi -->
    <div class="modal fade" tabindex="-1" id="chatbi_modal" data-bs-backdrop="static" aria-label="Close" ref="closeModal" data-bs-keyboard="false">
      <div class="modal-dialog modal-xl border border-3 border-primary rounded-0">
        <div class="modal-content shadow-none rounded-0">
          <div class="modal-header rounded-0 p-5">
            <div class="modal-title">
              <h5 class="ms-1">ChatBi © CreatorCUBE Edition</h5>
              <div class="d-flex flex-wrap rounded border bg-light p-1 mt-2" v-if="this.liabilityDetails.id !== null">
                <div class="d-flex flex-column me-10">
                  <div class="fw-bold">
                    <span class="me-1"> <i class="bi bi-hourglass-top text-warning fs-6"></i> </span>
                    <span class="fs-7 text-gray-700 fw-bold">{{previewDate(this.liabilityDetails.value_date)}}</span>
                  </div>
                </div>
                <div class="d-flex flex-column me-10">
                  <div class="fw-bold">
                    <span class="me-1"> <i class="bi bi-bookmark-fill text-success fs-7"></i> </span>
                    <span class="fs-7 text-gray-700 fw-bold">{{this.liabilityDetails.liability_type_name}}</span>
                  </div>
                </div>
                <div class="d-flex flex-column me-10">
                  <div class="fw-bold">
                    <span class="me-1"> <i class="bi bi-bookmarks-fill text-info fs-7"></i> </span>
                    <span class="fs-7 text-gray-700 fw-bold">{{this.liabilityDetails.liability_group_name}}</span>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <div class="fw-bold text-center">
                    <span class="fs-4 badge badge-light-danger fs-base mt-n3" v-if="this.liabilityDetails.amount_type != 0"> {{this.liabilityDetails.amount}} </span>
                    <small class="text-gray-700 fw-bold" v-if="this.liabilityDetails.amount_type != 0"> {{this.localCurrency}} </small>

                    <span class="fs-7 badge badge-light-danger mt-n3" v-if="this.liabilityDetails.amount_type == 0"> No Amount </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="btn btn-sm btn-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close" @click="getTotalMessageCount(), onRefreshLiabilityMessageCount()">
              Close Chat Window
            </div>
          </div> 
          <div class="modal-body rounded-0 p-3">
            <div class="d-flex flex-row row">
              <div class="d-flex flex-column flex-row-auto col-lg-4">
                <div class="d-flex flex-column-fluid card card-xxl-stretch">
                  <div class="card-body p-5" id="kt_chat_contacts_body">
                    <div v-if="isViewControllerChatGroups" class="mh-350px menu rounded menu-column menu-title-gray-700 menu-icon-gray-600 menu-arrow-gray-600 resize-vertical shadow-sm
                      menu-bullet-gray-400 menu-arrow-gray-400 menu-state-bg fw-semibold scroll-y p-5">
                      <div class="menu-item menu-sub-indention menu-accordion" v-for="groupItem in orderedGroupList" v-bind:key="groupItem">
                        <div class="d-flex flex-center bg-hover-light rounded cursor-pointer pb-1" @click="setActiveChat(groupItem)" v-if="groupItem.chat_type !== 2 && groupItem.parent_group == ''"
                          :class="{'bg-light': groupItem.id == this.activeChat.id}">
                          <div class="d-flex align-items-center">
                            <div class="symbol symbol-30px symbol-circle">
                              <span class="symbol-label fw-bolder" :class="{'bg-light-primary': groupItem.chat_type !== 3}">
                                <i class="fa fa-solid fa-user fs-6" v-if="groupItem.chat_type == 3"></i>
                                <i class="fa fa-solid fa-users fs-5 text-primary" v-if="groupItem.chat_type !== 3"></i>
                              </span>
                            </div>
                            <div>
                              <a href="#" class="menu-link">
                                <span class="menu-title text-gray-700 fs-7" data-bs-toggle="tooltip" data-bs-trigger="hover" :title="groupItem.name" :class="{'fw-bolder': groupItem.chat_type !== 3}">
                                  {{ groupItem.name.substring(0, 20) }}
                                  <span v-if="groupItem.name.length > 20">...</span>
                                </span>
                              </a>
                            </div>
                          </div>
                          <div class="ms-auto">
                            <span class="badge badge-circle badge-light-success me-3" v-if="groupItem.message_count > 0">
                              {{groupItem.message_count}}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Company groups -->
                    <div v-if="this.companyGroupsList.length > 0" class="mh-350px menu rounded menu-column menu-title-gray-700 menu-icon-gray-600 menu-arrow-gray-600 resize-vertical shadow-sm
                      menu-bullet-gray-400 menu-arrow-gray-400 menu-state-bg fw-semibold scroll-y p-5" :class="{'mt-10': isViewControllerChatGroups}"> 
                      <div class="menu-item menu-sub-indention menu-accordion" v-for="(cpGroupItem, index) in companyGroupsList" v-bind:key="cpGroupItem">
                        <div class="d-flex flex-stack bg-hover-light rounded cursor-pointer pb-1" @click="setActiveChat(cpGroupItem)"
                          v-if="cpGroupItem.chat_type == 2 || cpGroupItem.parent_group !== ''" :class="{'bg-light': cpGroupItem.id == this.activeChat.id}">
                          <div class="d-flex align-items-center">
                            <div class="symbol symbol-30px symbol-circle">
                              <span class="symbol-label fw-bolder" :class="{'bg-light-primary': cpGroupItem.chat_type !== 3}">
                                <i class="fa fa-solid fa-user fs-6" v-if="cpGroupItem.chat_type == 3"></i>
                                <i class="fa fa-solid fa-users fs-5 text-primary" v-if="cpGroupItem.chat_type !== 3"></i>
                              </span>
                            </div>
                            <div class="ms-5">
                              <a href="#" class="fs-7 text-gray-700">
                                <span class="menu-title" data-bs-toggle="tooltip" data-bs-trigger="hover" :title="cpGroupItem.name" :class="{'fw-bolder': cpGroupItem.chat_type !== 3}">
                                  {{ cpGroupItem.name.substring(0, 20) }}
                                  <span v-if="cpGroupItem.name.length > 20">...</span>
                                </span>
                                <div class="fw-semibold text-muted fs-8"> 
                                  <small> 
                                    {{ cpGroupItem.parent_group.substring(0, 25) }}
                                    <span v-if="cpGroupItem.parent_group.length > 25">...</span>
                                  </small>
                                </div>
                              </a>
                            </div>
                          </div>
                          <div class="ms-auto">
                            <span class="badge badge-circle badge-light-success me-3" v-if="cpGroupItem.message_count > 0">
                              {{cpGroupItem.message_count}}
                            </span>
                            <div class="collapsible cursor-pointer rotate" data-bs-toggle="collapse" :data-bs-target="'#company_group_'+ index">
                              <span class="svg-icon svg-icon-3 rotate-180">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z" fill="currentColor"></path>
                                  </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div :id="'company_group_'+ index" class="collapse menu-sub menu-sub-accordion show">
                          <div class="menu-item" v-for="ctUserItem in companyUsersList(cpGroupItem)" v-bind:key="ctUserItem">
                            <a href="#" class="menu-link bg-hover-light"
                              @click="setActiveChat(ctUserItem)" :class="{'bg-light': ctUserItem.id == this.activeChat.id}">
                              <span class="menu-bullet me-3">
                                <div class="symbol symbol-25px symbol-circle">
                                  <span class="symbol-label fw-bolder">
                                    <i class="fa fa-solid fa-user fs-6"></i>
                                  </span>
                                </div>
                              </span>
                              <span class="menu-title">{{ ctUserItem.name }}</span>
                              <span class="badge badge-circle badge-light-warning" v-if="ctUserItem.message_count > 0">
                                {{ctUserItem.message_count}}
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> 
                </div>
              </div>
              <div class="d-flex flex-column flex-row-auto col-lg-8"> 
                  <div class="d-flex flex-column-fluid card bgi-no-repeat h-400px" v-if="this.activeChat.id == null"
                    style="background-color: #009ef7; background-position: calc(100% + 1rem) bottom; background-size: 25% auto; background-image:url('/assets/theme/media/svg/humans/custom-1.svg')">
                      <div class="card-body d-flex flex-column align-items-start justify-content-center">
                          <h3 class="text-white fw-bold mb-3">Welcome to ChatBi © CreatorCUBE Edition</h3>
                          <h4 class="text-white fs-4">Please select a user to start chatting. </h4>
                      </div>
                  </div>
                  <div class="d-flex flex-column-fluid card bgi-no-repeat h-400px" v-if="this.activeChat.id != null && !isGroupHaveUsers" v-cloak>
                      <div class="card-body d-flex flex-column align-items-center justify-content-center">                                    
                        <div class="d-flex flex-center w-80px h-80px rounded-3 bg-light-danger bg-opacity-90 mb-10">
                          <span class="svg-icon svg-icon-muted svg-icon-3hx"><svg width="14" height="21" viewBox="0 0 14 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path opacity="0.3" d="M12 6.20001V1.20001H2V6.20001C2 6.50001 2.1 6.70001 2.3 6.90001L5.6 10.2L2.3 13.5C2.1 13.7 2 13.9 2 14.2V19.2H12V14.2C12 13.9 11.9 13.7 11.7 13.5L8.4 10.2L11.7 6.90001C11.9 6.70001 12 6.50001 12 6.20001Z" fill="currentColor"/>
                          <path d="M13 2.20001H1C0.4 2.20001 0 1.80001 0 1.20001C0 0.600012 0.4 0.200012 1 0.200012H13C13.6 0.200012 14 0.600012 14 1.20001C14 1.80001 13.6 2.20001 13 2.20001ZM13 18.2H10V16.2L7.7 13.9C7.3 13.5 6.7 13.5 6.3 13.9L4 16.2V18.2H1C0.4 18.2 0 18.6 0 19.2C0 19.8 0.4 20.2 1 20.2H13C13.6 20.2 14 19.8 14 19.2C14 18.6 13.6 18.2 13 18.2ZM4.4 6.20001L6.3 8.10001C6.7 8.50001 7.3 8.50001 7.7 8.10001L9.6 6.20001H4.4Z" fill="currentColor"/>
                          </svg>
                          </span>
                        </div>
                        <h1 class="mb-5">There is no user in this group..!</h1>
                        <div class="fs-4 text-gray-600 py-3">
                            Please add user to a group to start chatting.
                        </div>
                      </div>
                  </div>
                  <div class="d-flex flex-column-fluid card card-xxl-stretch" v-if="this.activeChat.id != null && isGroupHaveUsers" id="kt_chat_messenger">
                    <div class="card-header" id="kt_chat_messenger_header"> 
                      <div class="card-title fs-5">
                        <div class="d-flex align-items-center">
                          <div class="symbol symbol-45px symbol-circle">
                            <span class="symbol-label fw-bolder bg-light-info">
                              <i class="bi bi-person-fill fs-2" v-if="activeChat.chat_type == 3"></i>
                              <i class="bi bi-people-fill fs-2" v-if="activeChat.chat_type !== 3"></i>
                            </span>
                          </div>
                          <div class="ms-3">
                            <a class="fs-5 fw-bolder text-gray-900 text-hover-primary me-1">{{ activeChat.name }}</a>
                          </div>
                        </div>
                      </div>
                    </div> 
                    <div class="card-body"> 
                        <div class="scroll-y me-n5 pe-5 h-450px" id="kt_chat_messenger_body" ref="kt_chat_messenger_body">
                            <div class="d-flex flex-column align-items-center">
                              <button type="button" class="btn btn-light btn-elevate-hover btn-circle btn-icon" data-kt-indicator="on" 
                                @click="loadMoreMessages()" v-if="messages.length > 29" data-bs-toggle="tooltip" data-bs-trigger="hover" title="Load more messages">
                               <span v-if="!this.isMessagesLoading"> <i class="fa fa fa-undo"></i> </span> 
                                <span class="indicator-progress" v-if="this.isMessagesLoading">
                                    <span class="spinner-border spinner-border-sm align-middle"></span>
                                </span>
                              </button>
                            </div>
                            <span v-for="(item) in messages" v-bind:key="item">
                                <div class="d-flex justify-content-start mb-5" v-if="item.sender_id != userData.id && ((item.chat_type !== 3 && activeChat.chat_type == item.chat_type && activeChat.id == item.receiver_id) || (item.chat_type == 3 && userData.id == item.receiver_id && activeChat.id == item.sender_id))
                                && (this.liabilityDetails.id !== null ? item.liability_id == this.liabilityDetails.id : true)">
                                    <div class="d-flex flex-column align-items-start"> 
                                      <div class="d-flex align-items-center">
                                        <div class="symbol symbol-45px me-3 symbol-circle">
                                            <span class="symbol-label bg-light-info text-info fw-bolder" v-if="item.sender_name != '' && item.sender_name != null">
                                                {{ getUserAlias(item.sender_name) }} 
                                            </span>
                                        </div>
                                        <div v-if="item.is_deleted !== 1" class="p-2 rounded bg-light-info text-gray-800 fw-semibold mw-lg-450px text-start" data-kt-element="message-text">                                              
                                          <div class="my-2">
                                            <a class="fw-bolder text-gray-900 text-hover-primary me-1">{{ item.sender_name }}</a>
                                            <div class="dropdown float-end">
                                              <span class="svg-icon svg-icon-2 cursor-pointer" data-toggle="dropdown" @click="onClickDropdown(item)">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z" fill="currentColor"></path>
                                                </svg>
                                              </span>
                                              <ul class="dropdown-menu" :class="{ 'show': item.isOpenActionsDropdown }"> 
                                                <li>
                                                  <a class="dropdown-item" href="#" @click="onReplyMessage(item)"> Reply </a>
                                                  <a class="dropdown-item" href="#" @click="onDeleteMessage(item)"
                                                    v-if="item.sender_mail == userData.user_mail && item.is_deleted !== 1"> Delete </a>
                                                </li>
                                              </ul>
                                            </div>    
                                          </div>
                                          <small class="d-flex flex-row" v-if="item.liability_id !== null && item.liability_id !== '' && item.liability_id !== undefined">
                                            <li class="d-flex align-items-center me-2">
                                                <span class="bullet bullet-sm bullet-dot me-1 bg-primary"></span>
                                                {{previewDate(item.value_date)}}
                                            </li>
                                            <li class="d-flex align-items-center me-2">
                                                <span class="bullet bullet-sm bullet-dot me-1 bg-warning"></span>
                                                {{item.liability_type_name}} 
                                            </li>
                                            <li class="d-flex align-items-center me-2">
                                                <span class="bullet bullet-sm bullet-dot me-1 bg-success"></span> 
                                                {{item.amount}}
                                            </li>
                                          </small>
                                          <div class="separator my-2 border-gray-300" v-if="item.liability_id !== null && item.liability_id !== '' && item.liability_id !== undefined"></div>

                                          <!-- Repllied message content: Start -->
                                          <div v-if="item.repliedMessageItems" class="bg-white mb-3 px-5 py-1 rounded text-gray-800 fw-semibold mw-lg-450px text-start border-start border-0 border-left-3" data-kt-element="message-text"
                                            :class="{'border-primary': item.repliedMessageItems.sender_mail == userData.user_mail, 'border-info': item.repliedMessageItems.sender_mail !== userData.user_mail}">
                                            <div v-if="item.repliedMessageItems.is_deleted !== 1">
                                              <div class="" v-if="item.repliedMessageItems.sender_mail !== userData.user_mail">
                                                <a class="fw-bolder text-gray-900 text-hover-primary me-1">{{ item.repliedMessageItems.sender_name }}</a>
                                              </div>
                                              <small class="d-flex flex-row" v-if="item.repliedMessageItems.liability_id !== null && item.repliedMessageItems.liability_id !== '' && item.repliedMessageItems.liability_id !== undefined">
                                                <li class="d-flex align-items-center me-2">
                                                    <span class="bullet bullet-sm bullet-dot me-1 bg-primary"></span>
                                                    {{previewDate(item.repliedMessageItems.value_date)}}
                                                </li>
                                                <li class="d-flex align-items-center me-2">
                                                    <span class="bullet bullet-sm bullet-dot me-1 bg-warning"></span>
                                                    {{item.repliedMessageItems.liability_type_name}} 
                                                </li>
                                                <li class="d-flex align-items-center me-2">
                                                    <span class="bullet bullet-sm bullet-dot me-1 bg-success"></span> 
                                                    {{item.repliedMessageItems.amount}}
                                                </li>
                                              </small>
                                              <div class="separator my-2 border-gray-300" v-if="item.repliedMessageItems.liability_id !== null && item.repliedMessageItems.liability_id !== '' && item.repliedMessageItems.liability_id !== undefined"></div>
                                              
                                              <!-- Replied Documents: Start -->
                                              <span v-if="item.repliedMessageItems.document_name !== null && item.repliedMessageItems.document_name !== '' && item.repliedMessageItems.document_name !== undefined">
                                                <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/jpg.png"
                                                  v-if="item.repliedMessageItems.document_extension == 'jpg'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                                <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/jpg.png"
                                                  v-if="item.repliedMessageItems.document_extension == 'jpeg'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />
                                                  
                                                <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/png.png"
                                                  v-if="item.repliedMessageItems.document_extension == 'png'" style="margin-right: auto; margin-left: auto;" width="50" height="50" /> 

                                                <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/gif.png"
                                                  v-if="item.repliedMessageItems.document_extension == 'gif'" style="margin-right: auto; margin-left: auto;" width="50" height="50" /> 

                                                <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/video.png"
                                                  v-if="item.repliedMessageItems.document_extension == 'mp4'" style="margin-right: auto; margin-left: auto;" width="50" height="50" /> 

                                                <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/doc.png"
                                                  v-if="item.repliedMessageItems.document_extension == 'doc'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                                <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/docx.png"
                                                  v-if="item.repliedMessageItems.document_extension == 'docx'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                                <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/pdf.png"
                                                  v-if="item.repliedMessageItems.document_extension == 'pdf'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                                <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/ppt.png"
                                                  v-if="item.repliedMessageItems.document_extension == 'ppt'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                                <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/ppt.png"
                                                  v-if="item.repliedMessageItems.document_extension == 'pptx'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                                <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/rar.png"
                                                  v-if="item.repliedMessageItems.document_extension == 'rar'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                                <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/rtf.png" 
                                                  v-if="item.repliedMessageItems.document_extension == 'rtf'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                                <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/txt.png"
                                                  v-if="item.repliedMessageItems.document_extension == 'txt'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                                <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/xls.png"
                                                  v-if="item.repliedMessageItems.document_extension == 'xls'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                                <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/xlsx.png"
                                                  v-if="item.repliedMessageItems.document_extension == 'xlsx'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                                <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/zip.png"
                                                  v-if="item.repliedMessageItems.document_extension == 'zip'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                                {{item.repliedMessageItems.document_name}}
                                                <br v-if="item.repliedMessageItems.message">
                                              </span>
                                              <!-- Replied Documents: End -->
                                              <span class="fs-7">{{ item.repliedMessageItems.message.substring(0, 100) }}</span>
                                              <br>
                                              <span class="text-muted" style="font-size:9px !important;">
                                                {{ item.repliedMessageItems.time }}
                                              </span>
                                            </div>
                                            <span class="fs-7" v-if="item.repliedMessageItems.is_deleted == 1"><i class="bi bi-x-circle"> This message was deleted </i></span>
                                          </div>
                                          <!-- Repllied message content: End -->

                                          <!-- Documents: Start -->
                                          <span v-if="item.document_name !== null && item.document_name !== '' && item.document_name !== undefined">
                                            <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/jpg.png"
                                              v-if="item.document_extension == 'jpg'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                            <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/jpg.png"
                                              v-if="item.document_extension == 'jpeg'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />
                                              
                                            <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/png.png"
                                              v-if="item.document_extension == 'png'" style="margin-right: auto; margin-left: auto;" width="50" height="50" /> 

                                            <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/gif.png"
                                              v-if="item.document_extension == 'gif'" style="margin-right: auto; margin-left: auto;" width="50" height="50" /> 

                                            <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/video.png"
                                              v-if="item.document_extension == 'mp4'" style="margin-right: auto; margin-left: auto;" width="50" height="50" /> 

                                            <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/doc.png"
                                              v-if="item.document_extension == 'doc'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                            <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/docx.png"
                                              v-if="item.document_extension == 'docx'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                            <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/pdf.png"
                                              v-if="item.document_extension == 'pdf'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                            <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/ppt.png"
                                              v-if="item.document_extension == 'ppt'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                            <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/ppt.png"
                                              v-if="item.document_extension == 'pptx'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                            <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/rar.png"
                                              v-if="item.document_extension == 'rar'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                            <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/rtf.png" 
                                              v-if="item.document_extension == 'rtf'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                            <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/txt.png"
                                              v-if="item.document_extension == 'txt'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                            <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/xls.png"
                                              v-if="item.document_extension == 'xls'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                            <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/xlsx.png"
                                              v-if="item.document_extension == 'xlsx'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                            <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/zip.png"
                                              v-if="item.document_extension == 'zip'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                            {{item.document_name}}
                                            <br v-if="item.message">
                                          </span>
                                          <!-- Documents: End -->
                                          <span>{{ item.message }}</span>
                                          <br>
                                          <span class="text-muted" style="font-size:9px !important;">{{ item.time }}</span>
                                        </div>
                                        <div v-if="item.is_deleted == 1" class="p-2 rounded bg-light-info text-gray-800 fw-semibold mw-lg-450px" data-kt-element="message-text">
                                          <i class="bi bi-x-circle"> This message was deleted </i>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end mb-5" v-if="item.sender_mail == userData.user_mail">
                                    <div class="d-flex flex-column align-items-end">
                                      <div  v-if="item.is_deleted !== 1" class="p-2 rounded bg-light-primary text-gray-800 fw-semibold mw-lg-450px" data-kt-element="message-text">
                                        <small class="d-flex flex-row" v-if="item.liability_id !== null && item.liability_id !== '' && item.liability_id !== undefined">
                                          <li class="d-flex align-items-center me-2">
                                              <span class="bullet bullet-sm bullet-dot me-1 bg-primary"></span>
                                              {{previewDate(item.value_date)}}
                                          </li>
                                          <li class="d-flex align-items-center me-2">
                                              <span class="bullet bullet-sm bullet-dot me-1 bg-warning"></span>
                                              {{item.liability_type_name}} 
                                          </li>
                                          <li class="d-flex align-items-center me-2">
                                              <span class="bullet bullet-sm bullet-dot me-1 bg-success"></span> 
                                              {{item.amount}}
                                          </li>
                                        </small>
                                        <div class="separator my-2 border-gray-300" v-if="item.liability_id !== null && item.liability_id !== '' && item.liability_id !== undefined"></div>
                                        <div class="d-flex justify-content-end">
                                          <div class="dropdown dropstart">
                                            <span class="svg-icon svg-icon-2 cursor-pointer" data-toggle="dropdown" @click="onClickDropdown(item)">
                                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z" fill="currentColor"></path>
                                              </svg>
                                            </span>
                                            <ul class="dropdown-menu dropdown-menu-start" style="right: 0;" :class="{ 'show': item.isOpenActionsDropdown }"> 
                                              <li>
                                                <a class="dropdown-item" href="#" @click="onReplyMessage(item)"> Reply </a>
                                                <a class="dropdown-item" href="#" @click="onDeleteMessage(item)"
                                                  v-if="item.sender_mail == userData.user_mail && item.is_deleted !== 1"> Delete </a>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        
                                        
                                        <!-- Repllied message content: Start -->
                                        <div v-if="item.repliedMessageItems" class="bg-white mb-3 px-5 py-1 rounded text-gray-800 fw-semibold mw-lg-450px text-start border-start border-0 border-left-3" data-kt-element="message-text"
                                          :class="{'border-primary': item.repliedMessageItems.sender_mail == userData.user_mail, 'border-info': item.repliedMessageItems.sender_mail !== userData.user_mail}">
                                          <div v-if="item.repliedMessageItems.is_deleted !== 1">
                                            <div class="" v-if="item.repliedMessageItems.sender_mail !== userData.user_mail">
                                              <a class="fw-bolder text-gray-900 text-hover-primary me-1">{{ item.repliedMessageItems.sender_name }}</a>
                                            </div>
                                            <small class="d-flex flex-row" v-if="item.repliedMessageItems.liability_id !== null && item.repliedMessageItems.liability_id !== '' && item.repliedMessageItems.liability_id !== undefined">
                                              <li class="d-flex align-items-center me-2">
                                                  <span class="bullet bullet-sm bullet-dot me-1 bg-primary"></span>
                                                  {{previewDate(item.repliedMessageItems.value_date)}}
                                              </li>
                                              <li class="d-flex align-items-center me-2">
                                                  <span class="bullet bullet-sm bullet-dot me-1 bg-warning"></span>
                                                  {{item.repliedMessageItems.liability_type_name}} 
                                              </li>
                                              <li class="d-flex align-items-center me-2">
                                                  <span class="bullet bullet-sm bullet-dot me-1 bg-success"></span> 
                                                  {{item.repliedMessageItems.amount}}
                                              </li>
                                            </small>
                                            <div class="separator my-2 border-gray-300" v-if="item.repliedMessageItems.liability_id !== null && item.repliedMessageItems.liability_id !== '' && item.repliedMessageItems.liability_id !== undefined"></div>
                                            
                                            <!-- Replied Documents: Start -->
                                            <span v-if="item.repliedMessageItems.document_name !== null && item.repliedMessageItems.document_name !== '' && item.repliedMessageItems.document_name !== undefined">
                                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/jpg.png"
                                                v-if="item.repliedMessageItems.document_extension == 'jpg'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/jpg.png"
                                                v-if="item.repliedMessageItems.document_extension == 'jpeg'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />
                                                
                                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/png.png"
                                                v-if="item.repliedMessageItems.document_extension == 'png'" style="margin-right: auto; margin-left: auto;" width="50" height="50" /> 

                                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/gif.png"
                                                v-if="item.repliedMessageItems.document_extension == 'gif'" style="margin-right: auto; margin-left: auto;" width="50" height="50" /> 

                                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/video.png"
                                                v-if="item.repliedMessageItems.document_extension == 'mp4'" style="margin-right: auto; margin-left: auto;" width="50" height="50" /> 

                                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/doc.png"
                                                v-if="item.repliedMessageItems.document_extension == 'doc'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/docx.png"
                                                v-if="item.repliedMessageItems.document_extension == 'docx'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/pdf.png"
                                                v-if="item.repliedMessageItems.document_extension == 'pdf'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/ppt.png"
                                                v-if="item.repliedMessageItems.document_extension == 'ppt'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/ppt.png"
                                                v-if="item.repliedMessageItems.document_extension == 'pptx'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/rar.png"
                                                v-if="item.repliedMessageItems.document_extension == 'rar'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/rtf.png" 
                                                v-if="item.repliedMessageItems.document_extension == 'rtf'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/txt.png"
                                                v-if="item.repliedMessageItems.document_extension == 'txt'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/xls.png"
                                                v-if="item.repliedMessageItems.document_extension == 'xls'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/xlsx.png"
                                                v-if="item.repliedMessageItems.document_extension == 'xlsx'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/zip.png"
                                                v-if="item.repliedMessageItems.document_extension == 'zip'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                              {{item.repliedMessageItems.document_name}}
                                              <br v-if="item.repliedMessageItems.message">
                                            </span>
                                            <!-- Replied Documents: End -->
                                            <span class="fs-7">{{ item.repliedMessageItems.message.substring(0, 100) }}</span>
                                            <br>
                                            <span class="text-muted" style="font-size:9px !important;">
                                              {{ item.repliedMessageItems.time }}
                                            </span>
                                          </div>
                                          <span class="fs-7" v-if="item.repliedMessageItems.is_deleted == 1"><i class="bi bi-x-circle"> This message was deleted </i></span>
                                        </div>
                                        <!-- Repllied message content: End -->

                                        
                                        <!-- Documents: Start -->
                                        <span v-if="item.document_name !== null && item.document_name !== '' && item.document_name !== undefined">
                                          <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/jpg.png"
                                            v-if="item.document_extension == 'jpg'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                          <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/jpg.png"
                                            v-if="item.document_extension == 'jpeg'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />
                                            
                                          <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/png.png"
                                            v-if="item.document_extension == 'png'" style="margin-right: auto; margin-left: auto;" width="50" height="50" /> 

                                          <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/gif.png"
                                            v-if="item.document_extension == 'gif'" style="margin-right: auto; margin-left: auto;" width="50" height="50" /> 

                                          <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/video.png"
                                            v-if="item.document_extension == 'mp4'" style="margin-right: auto; margin-left: auto;" width="50" height="50" /> 

                                          <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/doc.png"
                                            v-if="item.document_extension == 'doc'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                          <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/docx.png"
                                            v-if="item.document_extension == 'docx'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                          <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/pdf.png"
                                            v-if="item.document_extension == 'pdf'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                          <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/ppt.png"
                                            v-if="item.document_extension == 'ppt'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                          <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/ppt.png"
                                            v-if="item.document_extension == 'pptx'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                          <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/rar.png"
                                            v-if="item.document_extension == 'rar'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                          <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/rtf.png" 
                                            v-if="item.document_extension == 'rtf'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                          <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/txt.png"
                                            v-if="item.document_extension == 'txt'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                          <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/xls.png"
                                            v-if="item.document_extension == 'xls'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                          <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/xlsx.png"
                                            v-if="item.document_extension == 'xlsx'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                          <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/zip.png"
                                            v-if="item.document_extension == 'zip'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                                          {{item.document_name}}
                                          <br v-if="item.message">
                                        </span>
                                        <!-- Documents: End -->
                                        <span>{{ item.message }}</span>
                                        <br>
                                        <span class="text-muted" style="font-size:9px !important;">{{ item.time }}</span>
                                      </div>
                                      
                                      <div v-if="item.is_deleted == 1" class="p-2 rounded bg-light-primary text-gray-800 fw-semibold mw-lg-450px" data-kt-element="message-text">
                                        <i class="bi bi-x-circle"> This message was deleted </i>
                                      </div>
                                    </div>
                                </div>  
                            </span>
                        </div>
                    </div>
                    <div class="card-footer pt-4">
                      <div v-if="repliedMessageItem !== null && repliedMessageItem !== undefined"
                        class="alert alert-dismissible d-flex flex-column flex-sm-row m-0 p-0 border-start border-0 border-left-3 mb-3"
                        :class="{'bg-light-primary border-primary': repliedMessageItem.sender_mail == userData.user_mail, 'bg-light-info border-info': repliedMessageItem.sender_mail !== userData.user_mail}">
                        <div class="d-flex align-items-center">
                          <div class="ms-5 p-2 rounded text-gray-800 fw-semibold mw-lg-450px text-start" :class="{'bg-light-primary': repliedMessageItem.sender_mail == userData.user_mail, 'bg-light-info': repliedMessageItem.sender_mail !== userData.user_mail}">
                            <div class="" v-if="repliedMessageItem.sender_mail !== userData.user_mail">
                              <a class="fw-bolder text-gray-900 text-hover-primary me-1">{{ repliedMessageItem.sender_name }}</a>
                            </div>
                            <small class="d-flex flex-row" v-if="repliedMessageItem.liability_id !== null && repliedMessageItem.liability_id !== '' && repliedMessageItem.liability_id !== undefined">
                              <li class="d-flex align-items-center me-2">
                                  <span class="bullet bullet-sm bullet-dot me-1 bg-primary"></span>
                                  {{previewDate(repliedMessageItem.value_date)}}
                              </li>
                              <li class="d-flex align-items-center me-2">
                                  <span class="bullet bullet-sm bullet-dot me-1 bg-warning"></span>
                                  {{repliedMessageItem.liability_type_name}} 
                              </li>
                              <li class="d-flex align-items-center me-2">
                                  <span class="bullet bullet-sm bullet-dot me-1 bg-success"></span> 
                                  {{repliedMessageItem.amount}}
                              </li>
                            </small>
                            <div class="separator my-2 border-gray-300" v-if="repliedMessageItem.liability_id !== null && repliedMessageItem.liability_id !== '' && repliedMessageItem.liability_id !== undefined"></div>
                            
                            <!-- Replied Documents: Start -->
                            <span v-if="repliedMessageItem.document_name !== null && repliedMessageItem.document_name !== '' && repliedMessageItem.document_name !== undefined">
                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/jpg.png"
                                v-if="repliedMessageItem.document_extension == 'jpg'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/jpg.png"
                                v-if="repliedMessageItem.document_extension == 'jpeg'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />
                                
                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/png.png"
                                v-if="repliedMessageItem.document_extension == 'png'" style="margin-right: auto; margin-left: auto;" width="50" height="50" /> 

                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/gif.png"
                                v-if="repliedMessageItem.document_extension == 'gif'" style="margin-right: auto; margin-left: auto;" width="50" height="50" /> 

                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/video.png"
                                v-if="repliedMessageItem.document_extension == 'mp4'" style="margin-right: auto; margin-left: auto;" width="50" height="50" /> 

                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/doc.png"
                                v-if="repliedMessageItem.document_extension == 'doc'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/docx.png"
                                v-if="repliedMessageItem.document_extension == 'docx'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/pdf.png"
                                v-if="repliedMessageItem.document_extension == 'pdf'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/ppt.png"
                                v-if="repliedMessageItem.document_extension == 'ppt'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/ppt.png"
                                v-if="repliedMessageItem.document_extension == 'pptx'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/rar.png"
                                v-if="repliedMessageItem.document_extension == 'rar'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/rtf.png" 
                                v-if="repliedMessageItem.document_extension == 'rtf'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/txt.png"
                                v-if="repliedMessageItem.document_extension == 'txt'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/xls.png"
                                v-if="repliedMessageItem.document_extension == 'xls'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/xlsx.png"
                                v-if="repliedMessageItem.document_extension == 'xlsx'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                              <img class="img-responsive cursor-pointer" src="/assets/theme/media/extensionImage/zip.png"
                                v-if="repliedMessageItem.document_extension == 'zip'" style="margin-right: auto; margin-left: auto;" width="50" height="50" />

                              {{repliedMessageItem.document_name}}
                              <br v-if="repliedMessageItem.message">
                            </span>
                            <!-- Replied Documents: End -->
                            <span class="fs-7">{{ repliedMessageItem.message.substring(0, 100) }}</span>
                          </div>
                        </div>
                        <button type="button" @click="cancelReply()" class="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto">
                          <span class="svg-icon svg-icon-1"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                          <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                          </svg>
                          </span>
                        </button>
                      </div>                      
                      <div class="bg-light" v-if="isViewFileUploader">
                        <!-- Show a warning message if no Document Locations defined -->
                        <div class="col-lg-12" v-if="this.documentLocation == null && isFileManagerReady">
                          <div class="alert alert-dismissible bg-light-danger d-flex flex-column flex-sm-row w-100 p-3">
                            <span class="svg-icon svg-icon-2x svg-icon-danger me-4 mb-sm-0">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M2 4V16C2 16.6 2.4 17 3 17H13L16.6 20.6C17.1 21.1 18 20.8 18 20V17H21C21.6 17 22 16.6 22 16V4C22 3.4 21.6 3 21 3H3C2.4 3 2 3.4 2 4Z" fill="currentColor"></path>
                                    <path d="M18 9H6C5.4 9 5 8.6 5 8C5 7.4 5.4 7 6 7H18C18.6 7 19 7.4 19 8C19 8.6 18.6 9 18 9ZM16 12C16 11.4 15.6 11 15 11H6C5.4 11 5 11.4 5 12C5 12.6 5.4 13 6 13H15C15.6 13 16 12.6 16 12Z" fill="currentColor"></path>
                                </svg>
                            </span>
                            <div class="d-flex flex-column pe-0 pe-sm-10">
                                <h5 class="fw-semibold">Document Location not found.</h5>
                                <small>No Document Location has been defined yet.</small>
                            </div>
                            <button type="button" class="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto" data-bs-dismiss="alert" @click="isViewFileUploader = false">
                              <span class="svg-icon svg-icon-1">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                      viewBox="0 0 24 24" fill="none">
                                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                                          transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                      <rect x="7.41422" y="6" width="16" height="2" rx="1"
                                          transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                                  </svg>
                              </span>    
                            </button>
                          </div>
                        </div>
                        <div class="row" v-if="this.documentLocation !== null && isFileManagerReady">
                          <div class="col-lg-11">
                            <DxFileUploader
                              multiple="false"
                              upload-mode="useButtons" 
                              :visible="true"
                              accept= "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv, application/pdf, image/*"
                              :upload-headers="getUploadHeaders()"
                              :on-uploaded="onUploadCompleted"
                              upload-url="/api/Folders/UploadDocumentByLocation"
                              :ref="'fileUploader'" />
                          </div>
                          <div class="col-lg-1">
                            <div class="btn btn-icon btn-sm btn-active-icon-primary float-end mt-3" @click="isViewFileUploader = false">
                                <span class="svg-icon svg-icon-1">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none">
                                        <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                                            transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                        <rect x="7.41422" y="6" width="16" height="2" rx="1"
                                            transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                                    </svg>
                                </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <form @submit.prevent="submit">
                        <div class="row">
                          <div class="col-lg-10">
                            <input type="text" class="form-control form-control-flush mb-3" rows="1" data-kt-element="input" placeholder="Type a message" v-model="this.chatBiForm.chatMessage"/>
                          </div>
                          <div class="col-lg-2">
                            <button class="btn btn-sm btn-icon btn-active-light-primary me-1 float-end mt-1" type="button" @click="onUploadFile()">
                              <i class="bi bi-upload fs-3"></i>
                            </button>
                          </div>
                        </div>
                        <div class="d-flex flex-stack justify-content-end mt-3">
                          <button class="btn btn-primary" type="submit" data-kt-element="send" 
                            @click="SendChatBiMessage(this.chatBiForm.chatMessage, null, null)"
                            :disabled="this.chatBiForm.chatMessage == '' || this.chatBiForm.chatMessage == null">
                            Send
                          </button>
                        </div>
                      </form>
                    </div>
                  </div> 
              </div>
            </div>
          </div>
          <div class="modal-footer p-1">
            <span class="badge badge-light fw-light fs-7 px-5">You are logged in as &nbsp; <strong> {{ userData.name_surname}} </strong></span> 
          </div>
        </div>
      </div>
    </div>
  </div>
</template>  

<style> 
 
</style>
<script>
import * as signalR from "@microsoft/signalr";
import axios from 'axios';
import moment from 'moment';
import { DxFileUploader} from 'devextreme-vue/file-uploader';
// import Swal from 'sweetalert2'; 
 import themes from "devextreme/ui/themes"; 


export default {
  name: "NavHeader",
  components:{
    DxFileUploader
  },
  setup() {
    // var connection = new signalR.HubConnectionBuilder()
    //   .withUrl("/chatbi", {
    //     skipNegotiation: true,
    //     transport: signalR.HttpTransportType.WebSockets,
    //   })
    //   .build();
    // console.log(connection);
  },
  data() {
    return {
      searchbar: '',
      isExpanded: false,
      userData: this.$getUser(),
      localCurrency: this.$getUser().currency_code,
      companyAccounts: [],
      form: {
        start_date: new Date(),
        companySelection: null,
        companySelectionPre: null,
      },
      selectedCompany: this.$getSessionStorage("selected_company") !== undefined && this.$getSessionStorage("selected_company") !== null ? this.$getSessionStorage("selected_company") : {id: null, text: null},
      activeStep: 1,

      /* ChatBi */
      messages: [],
      connection: "",
      chatBiForm: {
        chatMessage: ""
      },
      activeChat: {
        id: null,
        name: null,
        user_mail: null,
        chat_type: 0
      },
      isGroupHaveUsers: true,
      isViewFileUploader: false,
      chatBiGroupsList: [],
      unReadMessageCount: 0,
      unReadCompanyMessageCount: 0,
      liabilityDetails: {
        id: null,
        liability_group_id: null,
        company_id: null,
        amount: null,
        liability_type_name: null,
        liability_group_name: null,
        value_date: null
      },
      isMessagesLoading: false,
      repliedMessageItem: null,
      uploadForm:  {
        document_type_id: null,
        importance: 0,
        document_source: null,
        upload_source: 0,
        source_company: null,
        source_person: null,
        have_personal_data: 0,
        have_gdpr_permission: 0,
        gdpr_description: null,
        document_name: null,
        document_no: null,
        document_description: null
      },
      documentLocation: null,
      isFileManagerReady: false,
      isViewControllerChatGroups: true,
      themeName: localStorage.getItem("data-bs-theme"),
    };
  },
  computed: {
    searchableCompanyAccountList() {
      return this.companyAccounts.filter(p => { 
        return p.text.toLowerCase().indexOf(this.searchbar.toLowerCase()) != -1 && p.id !== this.userData.id;
      });
    },
    selectedCompanyName() {
      return this.selectedCompany.text;
    },
    selectedCompanyId() {
      return this.$getSessionStorage("selected_company").id;
    },
    orderedGroupList() {
      return this.chatBiGroupsList.slice().sort((a, b) => new Date(b.last_message_time)- new Date(a.last_message_time));
    },
    orderedUserList(){
      return (value)=>{
       if (value !== null && value !== '' && value !== undefined) {
          return value.slice().sort((a, b) => new Date(b.last_message_time)- new Date(a.last_message_time));
        }
      }
    },
    getUserAlias() {
      return (value)=>{
       if (value !== null && value !== '' && value !== undefined) {
          return value.split(' ', 3).map(x => x !== '' ? x[0].toUpperCase() : '').join('.');
        }
      }
    },    
    companyGroupsList() {
      return this.chatBiGroupsList.filter(p => {
        return p.chat_type == 2;
      }).slice().sort((a, b) => new Date(b.last_message_time)- new Date(a.last_message_time));
    },    
    companyUsersList() {
      return (value)=>{
       if (value !== null && value !== '' && value !== undefined) {
          return this.chatBiGroupsList.filter(p => {
            return p.chat_type == 3 && p.parent_group == value.id;
          }).slice().sort((a, b) => new Date(b.last_message_time)- new Date(a.last_message_time));
        }
      }
    },
    previewDate(){
      return (value)=>{
       if (value) {
          return moment(new Date(value)).format('DD.MM.YYYY')
        }
      }
    },
  },
  methods: {
    getData() {
      this.$router.push({ name: 'Home' });
      const companyParams = {
        session_id: this.$getUser().session_id,
        controller_id: this.$getUser().controller_account_id
      }
      axios.post("/api/Accounts/CompanyAccounts", companyParams, {'Content-Type': 'application/json'})
      .then((companyResponse) => { 
        this.companyAccounts = companyResponse.data;
        this.companyAccounts.forEach(element => {
          element.company_name = this.$unlock(element.company_name);
          element.text = this.$unlock(element.text);
          element.company_vkn = this.$unlock(element.company_vkn);
          element.primary_person = this.$unlock(element.primary_person);
          element.company_gsm = this.$unlock(element.company_gsm);
          element.company_landphone = this.$unlock(element.company_landphone);
          element.company_email = this.$unlock(element.company_email);
          element.company_address = this.$unlock(element.company_address);
          element.company_city = this.$unlock(element.company_city);
          element.company_town = this.$unlock(element.company_town);
          element.company_state = this.$unlock(element.company_state);
          element.company_region = this.$unlock(element.company_region);
          element.company_postcode = this.$unlock(element.company_postcode);
          element.company_country_code = this.$unlock(element.company_country_code);
          element.controller_id = this.$unlock(element.controller_id);
          element.controller_account_name = this.$unlock(element.controller_account_name);
          element.system_access_name = this.$unlock(element.system_access_name);
          element.controller_access_name = this.$unlock(element.controller_access_name);
        });
      })
      .catch(function (error) {
        console.error(error);
      });
    },
    collapse() {
      this.isExpanded = false;
    }, 
    toggle() {
      this.isExpanded = !this.isExpanded;
    }, 
    signOut(){      
      this.$removeUser('user_' + this.$getUser().session_id);
      sessionStorage.clear();
      this.$router.push({ name: 'Login' });
    },
    onSelectCompany(item) {
      const params = {
        session_id: this.$getUser().session_id,
        company_id: item.id
      }
      axios.post("/api/CompanyManagement/SetCompanyToSession", params, {'Content-Type': 'application/json'})
      .then((response) => {
        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
          item.activeYear = response.data.company_active_period_id;
          item.localCurrency = response.data.currency_code;
          item.list_date_range = response.data.list_date_range;
          item.currency_search_type = response.data.currency_search_type;
          this.selectedCompany = item;
          this.$setSessionStorage("selected_company", item);
          this.$refs.Close.click();
          this.$router.push({ name: 'CompanyOverview' });
          window.document.title = item.text + ' | CreatorCUBE';
          this.getTotalMessageCount();
        }
      })
      .catch(function (error) {
        console.error(error); 
      });
    },
    onExitCompany() {
      const params = {
        session_id: this.$getUser().session_id,
        company_id: null /* Session üzerinden company_id bilgisini temizliyoruz */
      }
      axios.post("/api/CompanyManagement/SetCompanyToSession", params, {'Content-Type': 'application/json'})
      .then((response) => {        
        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == '') {
          this.selectedCompany = {id: null, text: null};
          this.$setSessionStorage("selected_company", this.selectedCompany);
          this.$router.push({ name: 'Home' }); 
          window.document.title = 'CreatorCUBE';
        }
      });
    },
    onNextStep() {
      this.activeStep++;
    },
    onBackStep() {
      this.activeStep--;
    },
    openCompanyAccountUpdate() {
      this.$setSessionStorage("cp_record_id", this.selectedCompany.id);
      this.$router.push({ name: 'CompanyAccountUpdate' });
    },
    onInstantLogin(item){
      const parameters = { 
        session_id: this.$getUser().session_id,
        company_id: item.id
      }; 
      axios.post('/api/Users/GetInstantAccessToken', parameters, {'Content-Type': 'application/json'})
      .then((response) => {
          window.open(this.$getUser().company_url + '/?s=' + response.data, '_blank');
      }) 
      .catch(function (error) {
          console.error(error);
          this.Progress.finish();
      });
    },


    /* CHATBI */    
    getTotalMessageCount() {
      const parameters = {
        session_id: this.$getUser().session_id
      };
      axios.post("/api/Chatbi/GetUnreadMessageCount", parameters, {"Content-Type": "application/json",})
      .then((response) => {  
        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
          this.unReadMessageCount = response.data.count;
          this.unReadCompanyMessageCount = response.data.company_message_count;
        }
      })
      .catch(function (error) {
        console.error(error);
        this.Progress.finish();
      });
    },
    onRefreshLiabilityMessageCount() {
      if(this.$route.path == '/Liabilities') { 
        this.emitter.emit('onReadLiabilityMessage', null);
      }
    },
    openChatBi(liabilityItem, selectedCompany){
      this.chatBiForm.chatMessage = "";
      this.isViewControllerChatGroups = true;
      this.activeChat = {
        id: null,
        name: null,
        user_mail: null,
        chat_type: 0
      };
      this.isGroupHaveUsers = true;
      this.liabilityDetails = {
        id: null,
        liability_group_id: null,
        company_id: null
      }
      if(liabilityItem !== null && liabilityItem !== undefined && liabilityItem !== '') {
        this.liabilityDetails = liabilityItem;
      }
      const params = {
        session_id: this.$getUser().session_id,
        liability_group_id: this.liabilityDetails.liability_group_id,
        company_id: this.liabilityDetails.company_id,
        liability_id: this.liabilityDetails.id
      };
      if(selectedCompany !== undefined && selectedCompany !== null && selectedCompany !== '') {
        params.company_id = selectedCompany;
        this.isViewControllerChatGroups = false;
      }
      axios.post("/api/Chatbi/Groups", params, {"Content-Type": "application/json",})
      .then((response) => {
        this.chatBiGroupsList = response.data;
      })
      .catch(function (error) {
        console.error(error);
      });
    },
    SendChatBiMessage: function(message, document_id, document_name) {
      if(message == null && message == '' && message == undefined) return;
      this.connection.invoke("SendChatBiMessage", 
        this.$getUser().user_mail,
        this.$getUser().name_surname,
        message, 
        this.$getUser().session_id,
        this.$getUser().id,
        this.activeChat.id,
        (this.repliedMessageItem !== null ? this.repliedMessageItem.id : null),
        this.activeChat.chat_type,
        this.liabilityDetails,
        document_id,
        document_name
      ).then((message_id) => {
        this.messages.push({
          id: message_id,
          sender_mail: this.$getUser().user_mail,
          sender_name: this.$getUser().name_surname,
          message: message,
          time: moment().format('DD.MM.YYYY HH:mm:ss'), 
          session_id: this.$getUser().session_id, 
          sender_id: this.$getUser().id, 
          receiver_id: this.activeChat.id,
          reply_id: (this.repliedMessageItem !== null && this.repliedMessageItem !== '') ? this.repliedMessageItem.id : null, 
          chat_type: this.activeChat.chat_type, 
          liability_id: this.liabilityDetails.id,
          value_date: this.liabilityDetails.value_date,
          amount: this.liabilityDetails.amount,
          liability_type_name: this.liabilityDetails.liability_type_name,
          repliedMessageItems: (this.repliedMessageItem !== null && this.repliedMessageItem !== '') ? this.getRepliedMessageItems(this.repliedMessageItem.id) : null,
          is_deleted: 0,
          document_name: document_name,
          document_extension: (document_name !== null && document_name !== undefined && document_name !== '') ? document_name.split('.')[document_name.split('.').length - 1] : null
        });
        try {
          this.$nextTick(() => {
            this.$refs.kt_chat_messenger_body.scrollTop = this.$refs.kt_chat_messenger_body.scrollHeight;
            this.repliedMessageItem = null;
            this.setMessagesAsRead();
          });
        } catch (Err) {
          console.error(Err);
        }  
      })
      .catch(function(err) {
        return console.error(err);
      });
        
      this.chatBiForm.chatMessage = ''; 
    },
    setActiveChat(item) {
      this.activeChat = {
        id: item.id,
        name: item.name,
        user_mail: item.user_mail,
        chat_type: item.chat_type /* 0-Main Controller Group, 1-Operation Group, 2-Company Group, 3-Private */
      };
      this.chatBiForm.chatMessage = "";
      this.repliedMessageItem = null;
      this.isGroupHaveUsers = true;
      this.isViewFileUploader = false;
      this.messages = [];
     
      if(item.chat_type == 2) {
        if(this.chatBiGroupsList.filter(i => i.parent_group == item.id).length == 0) {
          this.isGroupHaveUsers = false;
        }
      }
      this.getMessages(item);
    },
    getMessages(item) {
      const parameters = {
        session_id: this.$getUser().session_id,
        receiver_id: this.userData.id ,
        sender_id:  item.id,
        chat_type: item.chat_type,
        liability_id: this.liabilityDetails.id,
        count: 0
      };
      axios.post("/api/Chatbi/GetChatbiMessages", parameters, {"Content-Type": "application/json",})
      .then((response) => {
        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
          response.data.forEach(element => {
            this.messages.push({
              id: element.id,
              sender_mail: element.sender_mail,
              sender_name: element.sender_name,
              message: element.message,
              time: element.time,
              sender_id: element.sender_id, 
              receiver_id: element.receiver_id,
              reply_id: element.reply_id, 
              chat_type: element.chat_type, 
              liability_id: element.liability_id,
              value_date: element.value_date,
              amount: element.amount,
              liability_type_name: element.liability_type_name,              
              repliedMessageItems: (element.reply_id !== null && element.reply_id !== '') ? this.getRepliedMessageItems(element.reply_id) : null,
              is_deleted: element.is_deleted,
              document_name: element.document_name,
              document_extension: (element.document_name !== null && element.document_name !== undefined && element.document_name !== '') ? element.document_name.split('.')[element.document_name.split('.').length - 1] : null
            });
          });
        }
        try {
        this.$nextTick(() => {
          this.$refs.kt_chat_messenger_body.scrollTop = this.$refs.kt_chat_messenger_body.scrollHeight;
            this.setMessagesAsRead();
        });
        } catch (Err) {
          console.error(Err);
        }
      })
      .catch(function (error) {
        console.error(error);
        this.Progress.finish();
      });
    },
    setMessagesAsRead() {
      const parameters = {
        session_id: this.$getUser().session_id,
        receiver_id: this.activeChat.id,
        chat_type: this.activeChat.chat_type,
        sender_id: null,
        liability_id: this.liabilityDetails.id
      };
      if(parameters.chat_type == 3) {
        parameters.receiver_id = this.userData.id;
        parameters.sender_id = this.activeChat.id;
      }
      axios.post("/api/Chatbi/SetMessagesAsRead", parameters, {"Content-Type": "application/json",})
      .then(() => {
        this.activeChat.message_count = 0;
        this.chatBiGroupsList.forEach(element => {
          if(element.id == this.activeChat.id && element.chat_type == this.activeChat.chat_type) {
            element.message_count = 0;
          }
          // if(element.users !== undefined && element.users !== null) {    
          //   element.users.forEach(user => {              
          //     if(user.id == this.activeChat.id && user.chat_type == this.activeChat.chat_type) { user.message_count = 0; }
          //   });
          // }
        });
      })
      .catch(function (error) {
        console.error(error);
        this.Progress.finish();
      });
    },
    getUnreadMessageCount(receiverId, senderId, chatType, liabilityId) {
      if (this.liabilityDetails.id !== null) {
        this.chatBiGroupsList.forEach(element => {
          if (receiverId == element.id && chatType == element.chat_type && senderId !== this.userData.id && (this.liabilityDetails.id == liabilityId)) {
            if (parseInt(element.message_count) > -1) {
              element.message_count = element.message_count + 1;
              element.last_message_time = moment().format('YYYY-MM-DD[T]HH:mm:ss');
            }
            else { element.message_count = 0; }
          }
          
          if (senderId == element.id && chatType == element.chat_type && receiverId == this.userData.id && (this.liabilityDetails.id == liabilityId)) {
            if (parseInt(element.message_count) > -1) {
              element.message_count = element.message_count + 1;
              element.last_message_time = moment().format('YYYY-MM-DD[T]HH:mm:ss');
            }
            else {
              element.message_count = 0;
            }
          }
        });
      } else {
        this.chatBiGroupsList.forEach(element => {
          if (receiverId == element.id && chatType == element.chat_type && senderId !== this.userData.id) {
            if (parseInt(element.message_count) > -1) {
              element.message_count = element.message_count + 1;
              element.last_message_time = moment().format('YYYY-MM-DD[T]HH:mm:ss');
            }
            else { element.message_count = 0; }
          }
          
          if (senderId == element.id && chatType == element.chat_type && receiverId == this.userData.id) {
            if (parseInt(element.message_count) > -1) {
              element.message_count = element.message_count + 1;
              element.last_message_time = moment().format('YYYY-MM-DD[T]HH:mm:ss');
            }
            else {
              element.message_count = 0;
            }
          }
        });
      }
      setTimeout(() => {
        this.getTotalMessageCount();
      }, 500);
    },
    loadMoreMessages () {
      this.isMessagesLoading = true;
      const parameters = {
        session_id: this.$getUser().session_id,
        receiver_id: this.userData.id ,
        sender_id:  this.activeChat.id,
        chat_type: this.activeChat.chat_type,
        liability_id: this.liabilityDetails.id,
        count: this.messages.length
      };
      const that = this;
      axios.post("/api/Chatbi/GetChatbiMessages", parameters, {"Content-Type": "application/json",})
      .then((response) => {          
        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
          response.data.forEach(element => {
            this.messages.unshift({
              sender_mail: element.sender_mail,
              sender_name: element.sender_name,
              message: element.message,
              time: element.time,
              sender_id: element.sender_id, 
              receiver_id: element.receiver_id,
              reply_id: element.reply_id, 
              chat_type: element.chat_type, 
              liability_id: element.liability_id,
              value_date: element.value_date,
              amount: element.amount,
              liability_type_name: element.liability_type_name,
              repliedMessageItems: (element.reply_id !== null && element.reply_id !== '') ? this.getRepliedMessageItems(element.reply_id) : null,
              is_deleted: element.is_deleted,
              document_name: element.document_name,
              document_extension: (element.document_name !== null && element.document_name !== undefined && element.document_name !== '') ? element.document_name.split('.')[element.document_name.split('.').length - 1] : null
            });
          });
        }
      })        
      .finally(function () { 
          setTimeout(() => {
              that.isMessagesLoading = false;
          }, 500);
      }); 
    },
    onClickDropdown(item) {
      this.messages.forEach(element => {
          if (item.id !== element.id) {
              element.isOpenActionsDropdown = false;
          }
      });
      item.isOpenActionsDropdown = !item.isOpenActionsDropdown;
    },
    onReplyMessage(item) {
      item.isOpenActionsDropdown = false;
      this.repliedMessageItem = item;
    },
    cancelReply() {
      this.repliedMessageItem = null;
    },
    onDeleteMessage(item) {
      item.isOpenActionsDropdown = false;      
      this.$swal.fire({
        title: 'Are you sure you want to delete this message?',
        confirmButtonColor: '#f1416c',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        icon: 'warning'
      }).then((result) => { 
        if (result.isConfirmed) {
            const params = {
                session_id: this.$getUser().session_id,
                id: item.id
            }; 
            axios.post('api/Chatbi/DeleteMessage', params, {'Content-Type': 'application/json'})
            .then((response) => { 
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){ 
                  this.connection.invoke("DeleteMessage", item.id).catch(function (err) {
                      return console.error(err.toString());
                  });
                }
            })
            .catch(function () { 
              this.$swal("Error.", "Data could not be deleted..Please refresh the page and try again..!", 'error'); 
            });  
        }
      })   
    },
    getRepliedMessageItems(replyId) {
      let repliedMessageItem = null;
      this.messages.forEach(element => {
        if(element.id == replyId) {
          repliedMessageItem = element;
        }
      });
      return repliedMessageItem;
    },
    onUploadFile() {
      this.isViewFileUploader = true;
      this.isFileManagerReady = false;
      const that = this;
      const parameters = { 
        session_id: this.$getUser().session_id,
        location: 5, //General
        location_type: 2, //ChatBi
        location_subtype: 0,
        account_id: null,
        company_account_id: this.$getUser().company_account_id,
        controller_account_id: this.$getUser().controller_account_id,
        is_transaction: null
      }; 
      axios.post('/api/Folders/GetDocumentLocations', parameters, {'Content-Type': 'application/json'})
      .then((response) => { 
        if(response.data.length > 0) { 
          this.documentLocation = response.data[0];
          // this.$refs.fileUploader.instance.reset();
        } else {
          this.documentLocation = null;
        }
      })
      .finally(function () {
        that.isFileManagerReady = true;
      });
    },
    getUploadHeaders(){
        return { 
            sid: this.$getUser().session_id,
            cid: this.$getUser().company_account_id,
            ctd: this.$getUser().controller_account_id,
            dos: 1, /* Source */
            ups: 3, /* Upload Source */
            hgp: this.uploadForm.have_gdpr_permission,
            hpd: this.uploadForm.have_personal_data,
            imp: 0,  /* Importance */
            lid: null,
            lci: this.documentLocation != null ? this.documentLocation.id : null,
            mid: this.documentLocation != null ? this.documentLocation.main_location : null,
            dti: this.documentLocation != null ? this.documentLocation.document_type_id : null,
        };
    },
    onUploadCompleted(e){
      const parameters = { 
        session_id: this.$getUser().session_id,
        fid: e.request.responseText,
        source_company: null,
        source_person: this.$getUser().name_surname,
        document_name: (e.file.name !== '' && e.file.name !== null && e.file.name !== undefined) ? e.file.name.split('.').slice(0, -1).join('.') : null,
        document_no: this.uploadForm.document_no,
        description: this.uploadForm.description,
        gdpr_description: this.uploadForm.gdpr_description
      }; 
      axios.post('/api/Folders/UpdateDocumentForChatBi', parameters, {'Content-Type': 'application/json'})
      .then(() => {
          this.isViewFileUploader = false;
          // this.$refs.fileUploader.instance.reset();
          this.SendChatBiMessage(this.chatBiForm.chatMessage, e.request.responseText, e.file.name);
        }) 
      .catch(function (error) {
          console.error(error);
          this.Progress.finish();
      });
    },
   changeTheme(theme) {
      if(theme == 'system') { this.themeName = window.matchMedia("(prefers-color-scheme: dark)").matches ? 'dark' : 'light';}
      else this.themeName = theme;

      themes.current("generic." + this.themeName);
      document.documentElement.setAttribute("data-bs-theme", this.themeName);
      localStorage.setItem("data-bs-theme", this.themeName);
      localStorage.setItem("data-bs-theme-mode", this.themeName);
    },
  },
  created() {
    try{
      if(this.selectedCompany !== null && this.selectedCompany !== undefined && this.selectedCompany !== '' && this.selectedCompany.id !== null){
        window.document.title = this.selectedCompany.text + ' | CreatorCUBE';
      }
      else{
        window.document.title = 'CreatorCUBE';
      }
    }catch(Err){console.error(Err);}
    
    if(this.userData.is_chatbi_user == 1 && this.userData.is_locked !== 1) {
      let that = this;
      this.connection = new signalR.HubConnectionBuilder()
      .withUrl("/chatbi", { skipNegotiation: true, transport: signalR.HttpTransportType.WebSockets, })
      .build();
      this.connection.on("ReceiveMessage", function (sender_mail,sender_name,message,time,session_id,sender_id,receiver_id,reply_id, chat_type,liabilityDetails, message_id, document_name) {
        // that.messages.push({sender_mail,sender_name,message,time,session_id,sender_id,receiver_id,reply_id, chat_type, liabilityDetails, message_id});
        that.messages.push({
          id: message_id,
          sender_mail: sender_mail,
          sender_name: sender_name,
          message: message,
          time: time, 
          session_id: session_id, 
          sender_id: sender_id, 
          receiver_id: receiver_id,
          reply_id: reply_id, 
          chat_type: chat_type, 
          liability_id: liabilityDetails.id,
          value_date: liabilityDetails.value_date,
          amount: liabilityDetails.amount,
          liability_type_name: liabilityDetails.liability_type_name,
          repliedMessageItems: (reply_id !== null && reply_id !== '') ? that.getRepliedMessageItems(reply_id) : null,
          is_deleted: 0,
          document_name: document_name,
          document_extension: (document_name !== null && document_name !== undefined && document_name !== '') ? document_name.split('.')[document_name.split('.').length - 1] : null
        });
        // console.log({sender_mail,sender_name,message,time,session_id,sender_id,receiver_id,reply_id, chat_type, liabilityDetails, message_id});
        if(liabilityDetails.id !== null && liabilityDetails.id !== '' && liabilityDetails.id !== undefined) { 
          that.emitter.emit('ReceiveLiabilityMessage', liabilityDetails.id);
        }
        that.getUnreadMessageCount(receiver_id, sender_id, chat_type, liabilityDetails.id);
        try {
          that.$nextTick(() => {
            if(that.activeChat.id !== null) { that.$refs.kt_chat_messenger_body.scrollTop = that.$refs.kt_chat_messenger_body.scrollHeight; }
          });
        } catch (Err) {
          console.error(Err);
        }      
      });
      this.connection.on("DeleteMessage", function (messageId) {
        that.messages.forEach(element => {
          if(element.id == messageId) { element.is_deleted = 1; }
        });
      });
      this.connection.on("GetChatbiMessages");
      this.connection.start().then(() => {
        this.connection.invoke("JoinAllGroups", this.$getUser().session_id)
        .catch(err => {
          console.error(err);
        });
      }).catch(err => {
        console.error(err);
      });

      if(this.userData.id !== null && this.userData.id !== '' && this.userData.id !== undefined) {this.getTotalMessageCount();}
    }
    
  },
  mounted() { 
    this.emitter.on("SelectCompany", item => {
      this.onSelectCompany(item);
    });
    this.emitter.on("openChatBi", item => {
      this.openChatBi(item);
    });
  }
};
</script>